webpackJsonp([1],{

/***/ "7sb+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/superagent/lib/client.js
var client = __webpack_require__("GG98");
var client_default = /*#__PURE__*/__webpack_require__.n(client);

// EXTERNAL MODULE: ./node_modules/superagent-no-cache/index.js
var superagent_no_cache = __webpack_require__("ZLT9");
var superagent_no_cache_default = /*#__PURE__*/__webpack_require__.n(superagent_no_cache);

// CONCATENATED MODULE: ./src/utils/callApi.js





var callApi_domain =  false ? process.env.API_HOST : location.protocol + '//' + location.hostname + '/api';

var METHOD_TYPE = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE'

  /**
   * XHRを実行
   * @param {string} apiPath APIのパス
   * @param {string} method Methodのタイプ
   * @param {object} params リクエストパラメータ
   * @param {object} options ヘッダーパラメータ
   * @return {Promise} リクエスト処理のPromise
   * TODO:header部分付与する。
   */
};function callApi(apiPath, method) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // URLを生成
  var endpoint = '' + callApi_domain + apiPath;
  var timeout = 60000;
  return new promise_default.a(function (resolve, reject) {
    var req = client_default()(method, endpoint).timeout(timeout).use(superagent_no_cache_default.a).withCredentials();
    // options(header)があれば付与する
    if (options !== null) {
      keys_default()(options).forEach(function (key) {
        if (options[key] !== null) {
          req.set(key, options[key]);
        }
      });
    }
    // GETの場合はqueryを
    if (method === METHOD_TYPE.GET) {
      req.query(params);
    }

    // POSTの場合はbodyを
    if (method === METHOD_TYPE.POST || method === METHOD_TYPE.PUT) {
      if (typeof params.file === 'undefined') {
        req.send(params);
      } else {
        keys_default()(params).forEach(function (key) {
          if (key !== 'file' && params[key] !== null) {
            req.field(key, params[key]);
          }
        });
        req.attach('image', params.file);
      }
    }

    req.then(function (res) {
      if (res.ok) {
        resolve(res);
      } else {
        // ajaxが失敗した
        reject(res);
      }
    }).catch(function (e) {
      // ajaxが失敗した
      /* eslint-disable */
      reject({
        message: e.message,
        status: e.status,
        response: e.response
      });
    });
  });
}
// CONCATENATED MODULE: ./src/mutations/index.js
// mutationsはここでまとめる

var SAMPLE = {
  INCREASE: 'SAMPLE__INCREASE',
  DECREASE: 'SAMPLE__DECREASE',
  API_SUCCESS: 'SAMPLE__API_SUCCESS',
  API_FAILED: 'SAMPLE__API_FAILED',
  INIT_DATA: 'SAMPLE__INIT_DATA'
};
var ACTION = {
  ACTION_LIST: 'ACTION__ACTION_LIST',
  ACTION_CREATE: 'ACTION__ACTION_CREATE',
  ACTION_UPDATE: 'ACTION__ACTION_UPDATE',
  ACTION_GET: 'ACTION__ACTION_GET',
  SCENARIO_LIST: 'ACTION__SCENARIO_LIST',
  MODEL: 'ACTION__MODEL',
  UPLOAD_IMAGE: 'ACTION__UPLOAD_IMAGE'
};
var DOMAIN = {
  DOMAIN_LIST: 'DOMAIN__DOMAIN_LIST',
  DOMAIN_CREATE: 'DOMAIN__DOMAIN_CREATE',
  DOMAIN_UPDATE: 'DOMAIN__DOMAIN_UPDATE',
  DOMAIN_GET: 'DOMAIN__DOMAIN_GET'
};
var FRAME = {
  FRAME_LIST: 'FRAME__FRAME_LIST',
  FRAME_CREATE: 'FRAME__FRAME_CREATE',
  FRAME_UPDATE: 'FRAME__FRAME_UPDATE',
  FRAME_GET: 'FRAME__FRAME_GET',
  ACTION_GET: 'FRAME__ACTION_GET',
  ACTION_LIST: 'FRAME__ACTION_LIST',
  DOMAIN_LIST: 'FRAME__DOMAIN_LIST',
  RATIO_CHANGE: 'FRAME__RATIO_CHANGE',
  ACTION_TYPE: 'FRAME__ACTION_TYPE',
  SEGMENT_LIST: 'FRAME__SEGMENT_LIST'
};

var DECISIONTREE = {
  DATASOURCE_LIST: 'DECISIONTREE__DATASOURCE_LIST',
  DECISIONTREE_LIST: 'DECISIONTREE__DECISIONTREE_LIST',
  DECISIONTREE_CREATE: 'DECISIONTREE__DECISIONTREE_CREATE',
  DECISIONTREE_UPDATE: 'DECISIONTREE__DECISIONTREE_UPDATE',
  DECISIONTREE_GET: 'DECISIONTREE__DECISIONTREE_GET'
};

var SIGNIN = {
  SIGNOUT: 'SIGNIN__SIGNOUT',
  SIGNIN: 'SIGNIN__SIGNIN'
};

var ACCOUNT = {
  ACCOUNT_ID: 'ACCOUNT__ACCOUNT_ID'
};
// CONCATENATED MODULE: ./src/stores/sample.js


var _mutations;




var sample_state = {
  counter: 0,
  successMessage: '',
  errorMessage: '',
  initDisplay: 'not call API yet'
};

var mutations = (_mutations = {}, defineProperty_default()(_mutations, SAMPLE.INIT_DATA, function (state, payload) {
  state.initDisplay = payload;
}), defineProperty_default()(_mutations, SAMPLE.INCREASE, function (state) {
  state.counter += 1;
}), defineProperty_default()(_mutations, SAMPLE.DECREASE, function (state) {
  state.counter -= 1;
}), defineProperty_default()(_mutations, SAMPLE.API_SUCCESS, function (state, payload) {
  state.successMessage = payload;
}), defineProperty_default()(_mutations, SAMPLE.API_FAILED, function (state, payload) {
  state.errorMessage = payload;
}), _mutations);

var actions = {
  getInitData: function getInitData(_ref) {
    var commit = _ref.commit;

    callApi('/api/init', METHOD_TYPE.GET).then(function (response) {
      commit(SAMPLE.INIT_DATA, response.body.result);
    });
  },
  increase: function increase(_ref2, counter) {
    var commit = _ref2.commit;

    commit(SAMPLE.INCREASE, counter);
  },
  decrease: function decrease(_ref3, counter) {
    var commit = _ref3.commit;

    commit(SAMPLE.DECREASE, counter);
  },
  callSuccess: function callSuccess(_ref4) {
    var commit = _ref4.commit;

    callApi('/api', METHOD_TYPE.GET).then(function (response) {
      commit(SAMPLE.API_SUCCESS, response.body.result);
    });
  },
  callFailed: function callFailed(_ref5) {
    var commit = _ref5.commit;

    callApi('/api/error', METHOD_TYPE.GET).catch(function (error) {
      commit(SAMPLE.API_FAILED, error.response.text);
    });
  }
};

/* harmony default export */ var sample = ({
  state: sample_state,
  actions: actions,
  mutations: mutations
});
// CONCATENATED MODULE: ./src/constants/index.js
// グローバルな定数などがあれば、ここに記載する
var regexp = /^[0-9a-zA-Z\\.-_]{1,150}$/;
var numberRegexp = /^([1-9]\d*|0)$/;
var treeIdRegexp = /^[a-zA-Z0-9\-\\_]{1,128}$/;
var nameRegexp = /^([\\u0000-\uffff&&[^\\x00-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]]){1,128}$/;
var modelRegexp = /[abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/+=¥r¥n]{1,16777216}$/;
var domainRegexp = /^[A-Za-z0-9][A-Za-z0-9-_.]+$/;
var pageNgRegexp = /^https?:\/\/.*$/;
var actionFormat = { actionId: '', versionId: '', mtime: '', utime: '', model: '', modelExtention: '', metadata: { name: '', type: '' }, configuration: {} };
var actionRecommendAiConfigurationFormat = { type: 'recommend-ai', scenarioId: '' };
var actionIconConfigurationFormat = { type: 'icon', downloadUrl: '', positionConfiguration: { widthUnits: '', heightUnits: '', widthType: '', heightType: '', width: '', height: '' }, textColor: '#666666', textLinkColor: '#00a0e9', textBackground: '#f6f6f6', userTextColor: '#ffffff', userTextBackground: '#10cfb2', buttonColor: '#00a0e9', buttonTextColor: '#ffffff', buttonAreaColor: '#f0f6fb' };
var actionPopupConfigurationFormat = { type: 'popup', url: '', downloadUrl: '', positionConfiguration: { widthUnits: '', heightUnits: '', widthType: '', heightType: '', width: '', height: '' }, size: { height: '', heightUnits: '', width: '', widthUnits: '' } };
var domainFormat = { fqdn: '', versionId: '', mtime: '', utime: '', metadata: { status: '' } };
var frameFormat = { fqdn: '', frameId: '', versionId: '', mtime: '', utime: '', metadata: { name: '' }, configuration: { pages: [{ pattern: '', mode: 'eq_display' }], actions: [], segments: [], rules: [] } };
var decisiontreeFormat = { datasourceId: '', treeId: '', versionId: '', metadata: { name: '' }, model: '' };
var actiontypes = ['popup', 'recommend-ai', 'icon'];
var POPUP = 'popup';
var RECOMMENDAI = 'recommend-ai';
var ICON = 'icon';
var UPLOAD_ICON_LIMITATION = { LIMIT: 1000000, TEXT: '1MB' };
var UPLOAD_POPUP_LIMITATION = { LIMIT: 5000000, TEXT: '5MB' };
var operatorList = ['lt', 'le', 'eq', 'ge', 'gt', 'ne'];
var strOperatorList = ['eq', 'ne'];
var periodTypeList = ['hour', 'day', 'week', 'month'];
var dayOfWeekList = ['1', '2', '3', '4', '5', '6', '7'];
var scopeList = ['all', 'previous', 'current'];
var dayList = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
var hourList = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
var minuteList = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'];
var weekList = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
var pageMode = { 'EQ_DISPLAY': '一致したら表示する', 'EQ_UNDISPLAY': '一致したら表示しない' };
var categoryList = { 'session': 'セッション', 'schedule': 'スケジュール', 'stop': '停止', 'eventhistory': '実行履歴' };
var categoryRuleList = {
  // 訪問回数(visit-count)は非表示にする
  'session': { 'last-page-view': '最後のページビュー日時', 'page-view-count': 'ページビュー数', 'stay-seconds': '滞在秒数', 'view-page-path': '閲覧ページのパス', 'last-page-path': '最後の閲覧ページのパス', 'walk-3pages': '3階層ページ遷移閲覧シナリオ', 'referer': 'リンク元ページ（リファラ）のホスト', 'utm-source': '閲覧ページのクエリキー（utm_source）', 'src-link-path': 'サイト内のリンク元ページのパス', 'user-os': 'アクセス時のOS名', 'stop-view-count': '配信回数上限で配信を停止' },
  'schedule': { 'day-period': '期間', 'day-of-week': '曜日', 'day-time': '時間' },
  'stop': { 'stop-view-count': '配信回数上限で配信を停止', 'stop-close-count': '閉じられた回数で配信を停止', 'stop-click-count': 'クリック回数で配信を停止' },
  'eventhistory': { 'frequency': '期間頻度', 'user-view-limit': 'ユーザー毎の発生回数' }
};
var ruleList = {
  'visit-count': '訪問回数',
  'last-page-view': '最後のページビュー日時',
  'page-view-count': 'ページビュー数',
  'stay-seconds': '滞在秒数',
  'view-page-path': '閲覧ページのパス',
  'last-page-path': '最後の閲覧ページのパス',
  'walk-3pages': '3階層ページ遷移閲覧シナリオ',
  'referer': 'リンク元ページ（リファラ）のホスト',
  'utm-source': '閲覧ページのクエリキー（utm_source）',
  'src-link-path': 'サイト内のリンク元ページのパス',
  'user-os': 'アクセス時のOS名',
  'stop-view-count': '配信回数上限で配信を停止',
  'stop-close-count': '閉じられた回数で配信を停止',
  'stop-click-count': 'クリック回数で配信を停止',
  'day-period': '期間',
  'day-of-week': '曜日',
  'day-time': '時間',
  'frequency': '期間頻度',
  'user-view-limit': 'ユーザー毎の発生回数'
};
var rulememoList = {
  'visit-count': 'セッション有効期限（30分）以上の間隔でサイトにアクセスした回数でルールを指定できる',
  'last-page-view': 'セッション有効期限（30分）以上の指定時間のアクセス間隔でルールを指定できる',
  'page-view-count': 'サイト内ページの表示回数、セッション内か過去のセッションを含むのかも指定できる',
  'stay-seconds': 'サイト内の滞在時間、以前のセッションからの継続時間でも設定できる',
  'view-page-path': '特定のページのパスの閲覧回数、セッション内か過去のセッションを含むのかも指定できる',
  'last-page-path': '直近のセッションの最後のページのパスを指定できる',
  'walk-3pages': '現在のセッションの３階層のページのパスで指定できる',
  'referer': 'サイトに来る前にいたページのホスト名（ドメイン）で指定できる',
  'utm-source': 'メールやLINEなど販促の際にリンクにつけるクエリーキー（タグ）で指定できる',
  'src-link-path': 'サイト内の１つ前に閲覧したページで指定できる',
  'user-os': 'ユーザーがアクセスしてきたOSの名前で指定できる',
  'stop-view-count': '指定回数配信を行ったら配信しないようにできる',
  'stop-close-count': '指定回数配信タブを閉じられたら配信しないようにできる',
  'stop-click-count': '指定回数リンクに飛んだら配信しないようにできる',
  'day-period': '期間（日時）で指定できる',
  'day-of-week': '曜日で指定できる',
  'day-time': '時間で指定できる',
  'frequency': '指定期間に1回のみ頻度を設定できる',
  'user-view-limit': 'ユーザー毎に発生する回数を指定できる'
};
var ruleFormatList = {
  'visit-count': { type: 'visit-count', count: '', operator: '' },
  'last-page-view': { type: 'last-page-view', threashold: '', operator: '' },
  'page-view-count': { type: 'page-view-count', scope: '', count: '', operator: '' },
  'stay-seconds': { type: 'stay-seconds', scope: '', seconds: '', operator: '' },
  'view-page-path': { type: 'view-page-path', scope: '', page: '', count: '', operator: '' },
  'last-page-path': { type: 'last-page-path', page: '', operator: '' },
  'walk-3pages': { type: 'walk-3pages', page1: '', page2: '', page3: '' },
  'referer': { type: 'referer', page: '', operator: '' },
  'utm-source': { type: 'utm-source', value: '', operator: '' },
  'src-link-path': { type: 'src-link-path', link: '', operator: '' },
  'user-os': { type: 'user-os', value: '', operator: '' },
  'stop-view-count': { type: 'stop-view-count', scope: '', count: '' },
  'stop-close-count': { type: 'stop-close-count', scope: '', count: '' },
  'stop-click-count': { type: 'stop-click-count', scope: '', count: '' },
  'day-period': { type: 'day-period', start: '', end: '', timezone: '' },
  'day-of-week': { type: 'day-of-week', values: ['', '', ''], timezone: '' },
  'day-time': { type: 'day-time', start: '', end: '', timezone: '' },
  'frequency': { type: 'frequency', periodType: '', timezone: '', interval: '', dayOfWeekThreshold: '', dayThreshold: '', hourThreshold: '', minuteThreshold: '' },
  'user-view-limit': { type: 'user-view-limit', scope: '', count: '' }
};
var jpList = {
  'count': '回数',
  'operator': '演算子',
  'threashold': '秒数',
  'scope': 'セッションの範囲',
  'seconds': '秒数',
  'page': 'ページパス',
  'page1': '２つ前のアクセスページパス',
  'page2': '１つ前のアクセスページパス',
  'page3': 'アクションの起きるアクセスページパス',
  'value': 'クエリーキー',
  'link': 'ページパス',
  'start': '開始',
  'end': '終了',
  'values': '曜日を英語で,区切りで入力してください',
  'timezone': 'タイムゾーン',
  'lt': 'より小さい',
  'le': '以下',
  'eq': '一致する',
  'ge': '以上',
  'gt': 'より大きい',
  'ne': '一致しない',
  'all': '今までのセッション全体から',
  'previous': '過去のセッションから',
  'current': '現セッションから',
  'periodType': '期間タイプ',
  'interval': '期間',
  'dayOfWeekThreshold': '区切りにする曜日',
  'dayThreshold': '区切りにする日',
  'hourThreshold': '区切りにする時間',
  'minuteThreshold': '区切りにする分',
  'hour': '時間で期間を作る',
  'day': '日で期間を作る',
  'week': '週で期間を作る',
  'month': '月で期間を作る',
  '1': '月曜日',
  '2': '火曜日',
  '3': '水曜日',
  '4': '木曜日',
  '5': '金曜日',
  '6': '土曜日',
  '7': '日曜日'
};

var timezoneList = {
  'Etc/GMT+12': '(UTC-12:00) 国際日付変更線 西側',
  'Etc/GMT+11': '(UTC-11:00) 協定世界時-11',
  'Pacific/Honolulu': '(UTC-10:00) ハワイ',
  'America/Anchorage': '(UTC-09:00) アラスカ',
  'America/Santa_Isabel': '(UTC-08:00) バハカリフォルニア',
  'America/Los_Angeles': '(UTC-08:00) 太平洋標準時(米国およびカナダ)',
  'America/Chihuahua': '(UTC-07:00) チワワ、ラパス、マサトラン',
  'America/Phoenix': '(UTC-07:00) アリゾナ',
  'America/Denver': '(UTC-07:00) 山地標準時(米国およびカナダ)',
  'America/Guatemala': '(UTC-06:00) 中央アメリカ',
  'America/Chicago': '(UTC-06:00) 中部標準時(米国およびカナダ)',
  'America/Regina': '(UTC-06:00) サスカチュワン',
  'America/Mexico_City': '(UTC-06:00) グアダラハラ、メキシコシティ、モンテレー',
  'America/Bogota': '(UTC-05:00) ボゴタ、リマ、キト',
  'America/Indiana/Indianapolis': '(UTC-05:00) インディアナ東部',
  'America/New_York': '(UTC-05:00) 東部標準時(米国およびカナダ)',
  'America/Caracas': '(UTC-04:30) カラカス',
  'America/Halifax': '(UTC-04:00) 大西洋標準時(カナダ)',
  'America/Asuncion': '(UTC-04:00) アスンシオン',
  'America/La_Paz': '(UTC-04:00) ジョージタウン、ラパス、マナウス、サンフアン',
  'America/Cuiaba': '(UTC-04:00) クイアバ',
  'America/Santiago': '(UTC-04:00) サンチアゴ',
  'America/St_Johns': '(UTC-03:30) ニューファンドランド',
  'America/Sao_Paulo': '(UTC-03:00) ブラジリア',
  'America/Godthab': '(UTC-03:00) グリーンランド',
  'America/Cayenne': '(UTC-03:00) カイエンヌ、フォルタレザ',
  'America/Argentina/Buenos_Aires': '(UTC-03:00) ブエノスアイレス',
  'America/Montevideo': '(UTC-03:00) モンテビデオ',
  'Etc/GMT+2': '(UTC-02:00) 協定世界時-2',
  'Atlantic/Cape_Verde': '(UTC-01:00) カーボベルデ諸島',
  'Atlantic/Azores': '(UTC-01:00) アゾレス',
  'Africa/Casablanca': '(UTC+00:00) カサブランカ',
  'Atlantic/Reykjavik': '(UTC+00:00) モンロビア、レイキャビク',
  'Europe/London': '(UTC+00:00) ダブリン、エジンバラ、リスボン、ロンドン',
  'Etc/GMT': '(UTC+00:00) 協定世界時',
  'Europe/Berlin': '(UTC+01:00) アムステルダム、ベルリン、ベルン、ローマ、ストックホルム、ウィーン',
  'Europe/Paris': '(UTC+01:00) ブリュッセル、コペンハーゲン、マドリード、パリ',
  'Africa/Lagos': '(UTC+01:00) 西中央アフリカ',
  'Europe/Budapest': '(UTC+01:00) ベオグラード、ブラチスラバ、ブダペスト、リュブリャナ、プラハ',
  'Europe/Warsaw': '(UTC+01:00) サラエボ、スコピエ、ワルシャワ、ザグレブ',
  'Africa/Windhoek': '(UTC+01:00) ウィントフック',
  'Europe/Istanbul': '(UTC+02:00) アテネ、ブカレスト、イスタンブール',
  'Europe/Kiev': '(UTC+02:00) ヘルシンキ、キエフ、リガ、ソフィア、タリン、ビリニュス',
  'Africa/Cairo': '(UTC+02:00) カイロ',
  'Asia/Damascus': '(UTC+02:00) ダマスカス',
  'Asia/Amman': '(UTC+02:00) アンマン',
  'Africa/Johannesburg': '(UTC+02:00) ハラーレ、プレトリア',
  'Asia/Jerusalem': '(UTC+02:00) エルサレム',
  'Asia/Beirut': '(UTC+02:00) ベイルート',
  'Asia/Baghdad': '(UTC+03:00) バグダッド',
  'Europe/Minsk': '(UTC+03:00) ミンスク',
  'Asia/Riyadh': '(UTC+03:00) クエート、リヤド',
  'Africa/Nairobi': '(UTC+03:00) ナイロビ',
  'Asia/Tehran': '(UTC+03:30) テヘラン',
  'Europe/Moscow': '(UTC+04:00) モスクワ、サンクトペテルブルグ、ボルゴグラード',
  'Asia/Tbilisi': '(UTC+04:00) トビリシ',
  'Asia/Yerevan': '(UTC+04:00) エレバン',
  'Asia/Dubai': '(UTC+04:00) アブダビ、マスカット',
  'Asia/Baku': '(UTC+04:00) バクー',
  'Indian/Mauritius': '(UTC+04:00) ポートルイス',
  'Asia/Kabul': '(UTC+04:30) カブール',
  'Asia/Tashkent': '(UTC+05:00) タシケント',
  'Asia/Karachi': '(UTC+05:00) イスラマバード、カラチ',
  'Asia/Colombo': '(UTC+05:30) スリジャヤワルダナプラコッテ',
  'Asia/Kolkata': '(UTC+05:30) チェンナイ、コルカタ、ムンバイ、ニューデリー',
  'Asia/Kathmandu': '(UTC+05:45) カトマンズ',
  'Asia/Almaty': '(UTC+06:00) アスタナ',
  'Asia/Dhaka': '(UTC+06:00) ダッカ',
  'Asia/Yekaterinburg': '(UTC+06:00) エカテリンブルグ',
  'Asia/Rangoon': '(UTC+06:30) ヤンゴン(ラングーン)',
  'Asia/Bangkok': '(UTC+07:00) バンコク、ハノイ、ジャカルタ',
  'Asia/Novosibirsk': '(UTC+07:00) ノヴォシビルスク',
  'Asia/Krasnoyarsk': '(UTC+08:00) クラスノヤルスク',
  'Asia/Ulaanbaatar': '(UTC+08:00) ウランバートル',
  'Asia/Shanghai': '(UTC+08:00) 北京、重慶、香港特別行政区、ウルムチ',
  'Australia/Perth': '(UTC+08:00) パース',
  'Asia/Singapore': '(UTC+08:00) クアラルンプール、シンガポール',
  'Asia/Taipei': '(UTC+08:00) 台北',
  'Asia/Irkutsk': '(UTC+09:00) イルクーツク',
  'Asia/Seoul': '(UTC+09:00) ソウル',
  'Asia/Tokyo': '(UTC+09:00) 大阪、札幌、東京',
  'Australia/Darwin': '(UTC+09:30) ダーウィン',
  'Australia/Adelaide': '(UTC+09:30) アデレード',
  'Australia/Hobart': '(UTC+10:00) ホバート',
  'Asia/Yakutsk': '(UTC+10:00) ヤクーツク',
  'Australia/Brisbane': '(UTC+10:00) ブリスベン',
  'Pacific/Port_Moresby': '(UTC+10:00) グアム、ポートモレスビー',
  'Australia/Sydney': '(UTC+10:00) キャンベラ、メルボルン、シドニー',
  'Asia/Vladivostok': '(UTC+11:00) ウラジオストク',
  'Pacific/Guadalcanal': '(UTC+11:00) ソロモン諸島、ニューカレドニア',
  'Etc/GMT-12': '(UTC+12:00) 協定世界時+12',
  'Pacific/Fiji': '(UTC+12:00) フィジー、マーシャル諸島',
  'Asia/Magadan': '(UTC+12:00) マガダン',
  'Pacific/Auckland': '(UTC+12:00) オークランド、ウェリントン',
  'Pacific/Tongatapu': '(UTC+13:00) ヌクアロファ',
  'Pacific/Apia': '(UTC+13:00) サモア'
};
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./src/stores/action.js


var action__mutations;






// 代入されるアクションリストの雛形
var action_state = {
  action: {},
  actionList: [],
  scenarioList: [],
  uploadedImage: '',
  downloadUrl: ''
};

var action_mutations = (action__mutations = {}, defineProperty_default()(action__mutations, ACTION.ACTION_LIST, function (state, payload) {
  state.actionList = payload;
}), defineProperty_default()(action__mutations, ACTION.ACTION_GET, function (state, payload) {
  state.action = payload;
  state.action.model = '';
  state.action.modelExtention = '';
  state.downloadUrl =  false ? 'https://res.pdq-dev.team-rec.jp/' + state.action.configuration.downloadUrl : location.protocol + '//' + location.hostname.replace('console', 'res') + '/' + state.action.configuration.downloadUrl;
}), defineProperty_default()(action__mutations, ACTION.SCENARIO_LIST, function (state, payload) {
  state.scenarioList = payload;
}), defineProperty_default()(action__mutations, ACTION.MODEL, function (state, payload) {
  state.action.model = payload.model;
  state.action.modelExtention = payload.modelExtention;
}), defineProperty_default()(action__mutations, ACTION.UPLOAD_IMAGE, function (state, payload) {
  state.uploadedImage = payload;
}), action__mutations);
var action_actions = {
  createAction: function createAction(_ref, router) {
    var commit = _ref.commit;

    var createParams = {
      actionId: action_state.action.actionId,
      metadata: action_state.action.metadata,
      configuration: {
        type: action_state.action.metadata.type
      }
    };
    if (action_state.action.metadata.type === RECOMMENDAI) {
      createParams.configuration.scenarioId = action_state.action.configuration.scenarioId;
    } else if (action_state.action.metadata.type === ICON) {
      createParams.configuration.positionConfiguration = action_state.action.configuration.positionConfiguration;
      createParams.configuration.textColor = action_state.action.configuration.textColor;
      createParams.configuration.textLinkColor = action_state.action.configuration.textLinkColor;
      createParams.configuration.textBackground = action_state.action.configuration.textBackground;
      createParams.configuration.userTextColor = action_state.action.configuration.userTextColor;
      createParams.configuration.userTextBackground = action_state.action.configuration.userTextBackground;
      createParams.configuration.buttonColor = action_state.action.configuration.buttonColor;
      createParams.configuration.buttonTextColor = action_state.action.configuration.buttonTextColor;
      createParams.configuration.buttonAreaColor = action_state.action.configuration.buttonAreaColor;
      createParams.model = action_state.action.model;
      createParams.modelExtention = action_state.action.modelExtention;
    } else if (action_state.action.metadata.type === POPUP) {
      createParams.configuration.url = action_state.action.configuration.url;
      createParams.configuration.size = action_state.action.configuration.size;
      createParams.configuration.positionConfiguration = action_state.action.configuration.positionConfiguration;
      createParams.model = action_state.action.model;
      createParams.modelExtention = action_state.action.modelExtention;
    }

    callApi('/delivery/create-action', METHOD_TYPE.POST, createParams).then(function (response) {
      alert('アクションの作成に成功しました');
      router.push('/delivery/list-action');
    }).catch(function (e) {
      if (e.response == null) {
        alert('アクションの作成に失敗しました。' + '\n' + e.message);
      } else {
        alert('アクションの作成に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  getActionListData: function getActionListData(_ref2) {
    var commit = _ref2.commit;

    callApi('/delivery/list-action', METHOD_TYPE.POST, {}).then(function (response) {
      commit(ACTION.ACTION_LIST, response.body.actions);
    }).catch(function (e) {
      if (e.response == null) {
        alert('アクションの取得に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('アクションの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  getActionData: function getActionData(_ref3) {
    var commit = _ref3.commit;

    callApi('/delivery/get-action', METHOD_TYPE.POST, { 'actionId': action_state.action.actionId }).then(function (response) {
      commit(ACTION.ACTION_GET, response.body.action);
    }).catch(function (e) {
      if (e.response == null) {
        alert('アクションの取得に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('アクションの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  formatActionData: function formatActionData(_ref4) {
    var commit = _ref4.commit;

    commit(ACTION.ACTION_GET, Object(lodash["cloneDeep"])(actionFormat));
  },
  updateAction: function updateAction(_ref5, router) {
    var commit = _ref5.commit;

    var updateParams = {
      actionId: action_state.action.actionId,
      versionId: action_state.action.versionId,
      metadata: action_state.action.metadata,
      configuration: {
        type: action_state.action.metadata.type
      }
    };
    if (action_state.action.metadata.type === RECOMMENDAI) {
      updateParams.configuration.scenarioId = action_state.action.configuration.scenarioId;
    } else if (action_state.action.metadata.type === ICON) {
      updateParams.configuration.positionConfiguration = action_state.action.configuration.positionConfiguration;
      updateParams.configuration.textColor = action_state.action.configuration.textColor;
      updateParams.configuration.textLinkColor = action_state.action.configuration.textLinkColor;
      updateParams.configuration.textBackground = action_state.action.configuration.textBackground;
      updateParams.configuration.userTextColor = action_state.action.configuration.userTextColor;
      updateParams.configuration.userTextBackground = action_state.action.configuration.userTextBackground;
      updateParams.configuration.buttonColor = action_state.action.configuration.buttonColor;
      updateParams.configuration.buttonTextColor = action_state.action.configuration.buttonTextColor;
      updateParams.configuration.buttonAreaColor = action_state.action.configuration.buttonAreaColor;
      updateParams.model = action_state.action.model;
      updateParams.modelExtention = action_state.action.modelExtention;
      updateParams.configuration.downloadUrl = action_state.action.configuration.downloadUrl;
    } else if (action_state.action.metadata.type === POPUP) {
      updateParams.configuration.url = action_state.action.configuration.url;
      updateParams.configuration.size = action_state.action.configuration.size;
      updateParams.configuration.positionConfiguration = action_state.action.configuration.positionConfiguration;
      updateParams.model = action_state.action.model;
      updateParams.modelExtention = action_state.action.modelExtention;
      updateParams.configuration.downloadUrl = action_state.action.configuration.downloadUrl;
    }
    callApi('/delivery/update-action', METHOD_TYPE.POST, updateParams).then(function (response) {
      alert('アクションの更新に成功しました');
      router.push('/delivery/list-action');
    }).catch(function (e) {
      if (e.response == null) {
        alert('アクションの更新に失敗しました。' + '\n' + e.message);
      } else {
        alert('アクションの更新に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  formatConfigurationData: function formatConfigurationData(_ref6) {
    var commit = _ref6.commit;

    if (action_state.action.metadata.type === 'popup') {
      action_state.action.configuration = actionPopupConfigurationFormat;
    } else if (action_state.action.metadata.type === 'recommend-ai') {
      action_state.action.configuration = actionRecommendAiConfigurationFormat;
    } else {
      action_state.action.configuration = actionIconConfigurationFormat;
    }
  },
  getScenarioList: function getScenarioList(_ref7) {
    var commit = _ref7.commit;

    callApi('/robotalk/list-scenario', METHOD_TYPE.POST, {}).then(function (response) {
      commit(ACTION.SCENARIO_LIST, response.body.scenarios);
    });
  },
  actionDelete: function actionDelete(_ref8, action) {
    var commit = _ref8.commit;

    callApi('/delivery/delete-action', METHOD_TYPE.POST, { actionId: action.actionId, versionId: action.versionId }).then(function (response) {
      commit(ACTION.ACTION_LIST, action_state.actionList.filter(function (n) {
        return n !== action;
      }));
    }).catch(function (e) {
      if (e.response == null) {
        alert('アクションの削除に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('アクションの削除に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  setModel: function setModel(_ref9, modelData) {
    var commit = _ref9.commit;

    commit(ACTION.MODEL, modelData);
  },
  setUploadedImage: function setUploadedImage(_ref10, uploadedImage) {
    var commit = _ref10.commit;

    commit(ACTION.UPLOAD_IMAGE, uploadedImage);
  }
};

/* harmony default export */ var stores_action = ({ state: action_state, actions: action_actions, mutations: action_mutations });
// CONCATENATED MODULE: ./src/stores/domain.js


var domain__mutations;






// 代入されるアクションリストの雛形
var domain_state = {
  domain: {},
  domainlist: []
};

var domain_mutations = (domain__mutations = {}, defineProperty_default()(domain__mutations, DOMAIN.DOMAIN_LIST, function (state, payload) {
  state.domainlist = payload;
}), defineProperty_default()(domain__mutations, DOMAIN.DOMAIN_GET, function (state, payload) {
  state.domain = payload;
}), domain__mutations);
var domain_actions = {
  createdomain: function createdomain(_ref, router) {
    var commit = _ref.commit;

    var createparams = {
      fqdn: domain_state.domain.fqdn,
      metadata: domain_state.domain.metadata
    };
    callApi('/delivery/create-domain', METHOD_TYPE.POST, createparams).then(function (response) {
      alert('ドメインの作成に成功しました');
      router.push('/delivery/list-domain');
    }).catch(function (e) {
      if (e.response == null) {
        alert('ドメインの作成に失敗しました。' + '\n' + e.message);
      } else {
        alert('ドメインの作成に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  getDomainListData: function getDomainListData(_ref2) {
    var commit = _ref2.commit;

    callApi('/delivery/list-domain', METHOD_TYPE.POST, {}).then(function (response) {
      commit(DOMAIN.DOMAIN_LIST, response.body.domains);
    }).catch(function (e) {
      if (e.response == null) {
        alert('ドメインの取得に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('ドメインの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  getDomainData: function getDomainData(_ref3) {
    var commit = _ref3.commit;

    callApi('/delivery/get-domain', METHOD_TYPE.POST, { 'fqdn': domain_state.domain.fqdn }).then(function (response) {
      commit(DOMAIN.DOMAIN_GET, response.body.domain);
    }).catch(function (e) {
      if (e.response == null) {
        alert('ドメインの取得に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('ドメインの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  formatDomainData: function formatDomainData(_ref4) {
    var commit = _ref4.commit;

    commit(DOMAIN.DOMAIN_GET, Object(lodash["cloneDeep"])(domainFormat));
  },
  updateDomain: function updateDomain(_ref5, router) {
    var commit = _ref5.commit;

    // paramsをここで作る。もっと頭のいい方法があったら変更する。
    var updateparams = {
      fqdn: domain_state.domain.fqdn,
      versionId: domain_state.domain.versionId,
      metadata: domain_state.domain.metadata
    };
    callApi('/delivery/update-domain', METHOD_TYPE.POST, updateparams).then(function (response) {
      alert('ドメインの更新に成功しました');
      router.push('/delivery/list-domain');
    }).catch(function (e) {
      if (e.response == null) {
        alert('ドメインの更新に失敗しました。' + '\n' + e.message);
      } else {
        alert('ドメインの更新に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  domainDelete: function domainDelete(_ref6, domain) {
    var commit = _ref6.commit;

    callApi('/delivery/delete-domain', METHOD_TYPE.POST, { fqdn: domain.fqdn, versionId: domain.versionId }).then(function (response) {
      commit(DOMAIN.DOMAIN_LIST, domain_state.domainlist.filter(function (n) {
        return n !== domain;
      }));
    }).catch(function (e) {
      if (e.response == null) {
        alert('ドメインの削除に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('ドメインの削除に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  }
};

/* harmony default export */ var stores_domain = ({ state: domain_state, actions: domain_actions, mutations: domain_mutations });
// CONCATENATED MODULE: ./src/stores/frame.js


var frame__mutations;






var frame_state = {
  frame: {},
  framelist: [],
  actionNames: {},
  actionList: {},
  segmentList: {},
  domainlist: {},
  fqdn: '',
  actionType: 'popup',
  nonRatio: 100
};

var frame_mutations = (frame__mutations = {}, defineProperty_default()(frame__mutations, FRAME.FRAME_LIST, function (state, payload) {
  state.framelist = payload;
}), defineProperty_default()(frame__mutations, FRAME.DOMAIN_LIST, function (state, payload) {
  state.domainlist = payload;
}), defineProperty_default()(frame__mutations, FRAME.FRAME_GET, function (state, payload) {
  state.frame = payload;
  state.nonRatio = 100 - Object(lodash["reduce"])(state.frame.configuration.actions, function (ratioSum, value, key) {
    return ratioSum + Number(value.ratio);
  }, 0);
}), defineProperty_default()(frame__mutations, FRAME.ACTION_GET, function (state, payload) {
  state.actionNames[payload.actionId] = payload.metadata.name;
}), defineProperty_default()(frame__mutations, FRAME.ACTION_LIST, function (state, payload) {
  state.actionList = payload;
}), defineProperty_default()(frame__mutations, FRAME.SEGMENT_LIST, function (state, payload) {
  console.log();
  state.segmentList = payload;
}), defineProperty_default()(frame__mutations, FRAME.RATIO_CHANGE, function (state) {
  var nonRatio = 100 - Object(lodash["reduce"])(state.frame.configuration.actions, function (ratioSum, value, key) {
    return ratioSum + Number(value.ratio);
  }, 0);
  if (nonRatio < 0) {
    state.nonRatio = 0;
  } else if (nonRatio > 100) {
    state.nonRatio = 100;
  } else {
    state.nonRatio = nonRatio;
  }
}), defineProperty_default()(frame__mutations, FRAME.ACTION_TYPE, function (state, payload) {
  state.actionType = payload;
}), frame__mutations);

var frame_actions = {
  getFrameListData: function getFrameListData(_ref, fqdn) {
    var commit = _ref.commit;

    callApi('/delivery/list-frame', METHOD_TYPE.POST, { 'fqdn': fqdn }).then(function (response) {
      commit(FRAME.FRAME_LIST, response.body.frames);
    }).catch(function (e) {
      if (e.response == null) {
        alert('枠の取得に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('枠の取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  getDomainListData: function getDomainListData(_ref2) {
    var commit = _ref2.commit;

    callApi('/delivery/list-domain', METHOD_TYPE.POST, {}).then(function (response) {
      commit(FRAME.DOMAIN_LIST, response.body.domains);
    }).catch(function (e) {
      if (e.response == null) {
        alert('ドメインの取得に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('ドメインの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  getFrameData: function getFrameData(_ref3, frameInf) {
    var _this = this;

    var commit = _ref3.commit;

    callApi('/delivery/get-frame', METHOD_TYPE.POST, { 'fqdn': frameInf.fqdn, 'frameId': frameInf.frameId }).then(function (response) {
      commit(FRAME.FRAME_GET, response.body.frame);
      // actionのnameが欲しいのでforぶん回す必要がある。改善方法があったら後で修正。

      var _loop = function _loop(i) {
        callApi('/delivery/get-action', METHOD_TYPE.POST, { 'actionId': frame_state.frame.configuration.actions[i].actionId }).then(function (response) {
          commit(FRAME.ACTION_GET, response.body.action);
          commit(FRAME.ACTION_TYPE, response.body.action.metadata.type);
          if (i === 0) {
            callApi('/delivery/list-action', METHOD_TYPE.POST, {}).then(function (response1) {
              commit(FRAME.ACTION_LIST, Object(lodash["filter"])(response1.body.actions, { 'metadata': { 'type': response.body.action.metadata.type } }));
            });
          }
        }).catch(function (e) {
          _this.errors.push(e);
        });
      };

      for (var i = 0; i < frame_state.frame.configuration.actions.length; i++) {
        _loop(i);
      }
    }).catch(function (e) {
      if (e.response == null) {
        alert('ドメインの取得に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('ドメインの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  formatFrameData: function formatFrameData(_ref4, fqdn) {
    var commit = _ref4.commit;

    var frame = Object(lodash["cloneDeep"])(frameFormat);
    frame.fqdn = fqdn;
    frame.configuration.pages[0].mode = '';
    commit(FRAME.FRAME_GET, frame);
  },
  getActionList: function getActionList(_ref5, actionType) {
    var commit = _ref5.commit;

    callApi('/delivery/list-action', METHOD_TYPE.POST, {}).then(function (response) {
      commit(FRAME.ACTION_LIST, Object(lodash["filter"])(response.body.actions, { 'metadata': { 'type': actionType } }));
    });
  },
  getSegmentList: function getSegmentList(_ref6, segment) {
    var commit = _ref6.commit;

    callApi('/delivery/list-segment', METHOD_TYPE.POST, {}).then(function (response) {
      commit(FRAME.SEGMENT_LIST, response.body.segments);
    });
  },
  createFrame: function createFrame(_ref7, router) {
    var commit = _ref7.commit;

    var params = frame_state.frame;
    callApi('/delivery/create-frame', METHOD_TYPE.POST, params).then(function (response) {
      alert('枠の登録に成功しました');
      router.push('/delivery/list-frame');
    }).catch(function (e) {
      if (e.response == null) {
        alert('枠の登録に失敗しました。' + '\n' + e.message);
      } else {
        alert('枠の登録に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  updateFrame: function updateFrame(_ref8, router) {
    var commit = _ref8.commit;

    var updateparams = frame_state.frame;
    callApi('/delivery/update-frame', METHOD_TYPE.POST, updateparams).then(function (response) {
      alert('枠の更新に成功しました');
      router.push('/delivery/list-frame');
    }).catch(function (e) {
      if (e.response == null) {
        alert('枠の更新に失敗しました。' + '\n' + e.message);
      } else {
        alert('枠の更新に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  frameDelete: function frameDelete(_ref9, frame) {
    var commit = _ref9.commit;

    callApi('/delivery/delete-frame', METHOD_TYPE.POST, { fqdn: frame.fqdn, frameId: frame.frameId, versionId: frame.versionId }).then(function (response) {
      commit(FRAME.FRAME_LIST, frame_state.framelist.filter(function (n) {
        return n !== frame;
      }));
    }).catch(function (e) {
      if (e.response == null) {
        alert('枠の削除に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('枠の削除に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  ratioChange: function ratioChange(_ref10) {
    var commit = _ref10.commit;

    commit(FRAME.RATIO_CHANGE);
  }
};

/* harmony default export */ var stores_frame = ({ state: frame_state, actions: frame_actions, mutations: frame_mutations });
// CONCATENATED MODULE: ./src/stores/decisiontree.js


var decisiontree__mutations;






// 代入される雛形
var decisiontree_state = {
  decisiontree: {},
  decisiontreelist: [],
  datasourceInList: [],
  datasourceId: ''
};

var decisiontree_mutations = (decisiontree__mutations = {}, defineProperty_default()(decisiontree__mutations, DECISIONTREE.DECISIONTREE_LIST, function (state, payload) {
  state.decisiontreelist = payload;
}), defineProperty_default()(decisiontree__mutations, DECISIONTREE.DECISIONTREE_GET, function (state, payload) {
  state.decisiontree.datasourceId = payload.datasourceId;
  state.decisiontree.treeId = payload.treeId;
  state.decisiontree.versionId = payload.versionId;
  state.decisiontree.name = payload.metadata.name;
  state.decisiontree.downloadUrl = payload.downloadUrl;
  state.decisiontree.model = payload.model;
}), defineProperty_default()(decisiontree__mutations, DECISIONTREE.DATASOURCE_LIST, function (state, payload) {
  state.datasourceInList = payload;
}), decisiontree__mutations);

var decisiontree_actions = {
  getDatasourceInListData: function getDatasourceInListData(_ref) {
    var commit = _ref.commit;

    callApi('/udata/list-datasource', METHOD_TYPE.POST, {}).then(function (response) {
      commit(DECISIONTREE.DATASOURCE_LIST, response.body.datasourceInList);
    });
  },
  getDecisiontreeListData: function getDecisiontreeListData(_ref2, datasourceId) {
    var commit = _ref2.commit;

    callApi('/udata/list-decision-tree', METHOD_TYPE.POST, { 'datasourceId': datasourceId, 'consistentRead': true }).then(function (response) {
      commit(DECISIONTREE.DECISIONTREE_LIST, response.body.decisionTrees);
    }).catch(function (e) {
      if (e.response == null) {
        alert('決定木の取得に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('決定木の取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  getDecisiontreeData: function getDecisiontreeData(_ref3) {
    var _this = this;

    var commit = _ref3.commit;

    callApi('/udata/get-decision-tree', METHOD_TYPE.POST, { 'datasourceId': decisiontree_state.decisiontree.datasourceId, 'treeId': decisiontree_state.decisiontree.treeId, 'consistentRead': true }).then(function (response) {
      commit(DECISIONTREE.DECISIONTREE_GET, response.body.decisionTree);
    }).catch(function (e) {
      _this.errors.push(e);
    });
  },
  formatDecisionTreeData: function formatDecisionTreeData(_ref4) {
    var commit = _ref4.commit;

    commit(DECISIONTREE.DECISIONTREE_GET, Object(lodash["cloneDeep"])(decisiontreeFormat));
  },
  createDecisionTree: function createDecisionTree(_ref5, router) {
    var commit = _ref5.commit;

    var createparams = decisiontree_state.decisiontree;
    callApi('/udata/create-decision-tree', METHOD_TYPE.POST, createparams).then(function (response) {
      alert('決定木の作成に成功しました');
      router.push('/udata/list-decision-tree');
    }).catch(function (e) {
      if (e.response == null) {
        alert('決定木の作成に失敗しました。' + '\n' + e.message);
      } else {
        alert('決定木の作成に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  updateDecisionTree: function updateDecisionTree(_ref6, router) {
    var commit = _ref6.commit;

    var updateparams = decisiontree_state.decisiontree;
    callApi('/udata/update-decision-tree', METHOD_TYPE.POST, updateparams).then(function (response) {
      alert('決定木の更新に成功しました');
      router.push('/udata/list-decision-tree');
    }).catch(function (e) {
      if (e.response == null) {
        alert('決定木の更新に失敗しました。' + '\n' + e.message);
      } else {
        alert('決定木の更新に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  },
  decisionTreeDelete: function decisionTreeDelete(_ref7, decisionTree) {
    var commit = _ref7.commit;

    callApi('/udata/delete-decision-tree', METHOD_TYPE.POST, { datasourceId: decisionTree.datasourceId, treeId: decisionTree.treeId, versionId: decisionTree.versionId }).then(function (response) {
      commit(DECISIONTREE.DECISIONTREE_LIST, decisiontree_state.decisiontreelist.filter(function (n) {
        return n !== decisionTree;
      }));
    }).catch(function (e) {
      if (e.response == null) {
        alert('決定木の削除に失敗しました。' + '\n' + e.message);
      } else {
        location.href = '#/error/' + e.status;
        alert('決定木の削除に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  }
};

/* harmony default export */ var decisiontree = ({ state: decisiontree_state, actions: decisiontree_actions, mutations: decisiontree_mutations });
// CONCATENATED MODULE: ./src/stores/signin.js


var signin__mutations;



var signin_state = {
  login: false
};

var signin_mutations = (signin__mutations = {}, defineProperty_default()(signin__mutations, SIGNIN.SIGNOUT, function (state) {
  state.login = false;
}), defineProperty_default()(signin__mutations, SIGNIN.SIGNIN, function (state) {
  state.login = true;
}), signin__mutations);

var signin_actions = {
  checkSessionId: function checkSessionId(_ref) {
    var commit = _ref.commit;

    // sessionidがnullの場合、ログインページに遷移する
    var name = 'sessionid';
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    var arr = document.cookie.match(reg);
    if (arr === null || arr[2] === null || arr[2] === '') {
      var domain =  false ? process.env.API_HOST + '/api/sign-in?key=localtest' : location.protocol + '//' + location.hostname + '/api/sign-in';
      location.href = domain;
    } else {
      commit(SIGNIN.SIGNIN);
      // ローカル環境以外の場合、サブドメインを抜ける
      if (true) {
        var index = location.hostname.indexOf('.console.pdq');
        if (index !== -1) {
          var upperLevelDomain = location.hostname.substring(index + 1);
          location.href = location.protocol + '//' + upperLevelDomain;
        }
      }
    }
  },
  signOut: function signOut(_ref2, router) {
    var commit = _ref2.commit;

    callApi('/sign-out', METHOD_TYPE.GET).then(function (response) {
      commit(SIGNIN.SIGNOUT);
      router.push('/');
    }).catch(function (e) {
      if (e.response == null) {
        alert('ログアウトに失敗しました' + '\n' + e.message);
      } else {
        alert('ログアウトに失敗しました' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  }
};

/* harmony default export */ var signin = ({ state: signin_state, actions: signin_actions, mutations: signin_mutations });
// CONCATENATED MODULE: ./src/stores/account.js




var account_state = {
  accountId: ''
};

var account_mutations = defineProperty_default()({}, ACCOUNT.ACCOUNT_ID, function (state, payload) {
  state.accountId = payload;
});

var account_actions = {
  getAccountId: function getAccountId(_ref) {
    var commit = _ref.commit;

    callApi('/account-id', METHOD_TYPE.GET).then(function (response) {
      commit(ACCOUNT.ACCOUNT_ID, response.body.accountId);
    }).catch(function (e) {
      commit(ACCOUNT.ACCOUNT_ID, 'アカウントIDの取得に失敗しました');
      if (e.response == null) {
        alert('アカウントIDの取得に失敗しました。' + '\n' + e.message);
      } else {
        alert('アカウントIDの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message);
      }
    });
  }
};

/* harmony default export */ var account = ({ state: account_state, actions: account_actions, mutations: account_mutations });
// CONCATENATED MODULE: ./src/stores/index.js










vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

// const debug = process.env.NODE_ENV !== 'production'

var store = new vuex_esm["a" /* default */].Store({
  modules: {
    sample: sample,
    action: stores_action,
    domain: stores_domain,
    frame: stores_frame,
    decisiontree: decisiontree,
    signin: signin,
    account: account
  },
  plugins: []
});

/* harmony default export */ var stores = (store);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      showConfiguration: 0,
      showManagement: 0,
      showSignOut: 0
    };
  },
  computed: {
    login: {
      get: function get() {
        return stores.state.signin.login;
      }
    },
    accountId: {
      get: function get() {
        return stores.state.account.accountId;
      }
    }
  },
  created: function created() {
    if (this.$route.name !== 'healthcheck') {
      stores.dispatch('checkSessionId');
      stores.dispatch('getAccountId');
    }
  },

  methods: {
    goSignOut: function goSignOut() {
      stores.dispatch('signOut', this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-352ef59c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-wrapper",attrs:{"id":"app"}},[_c('header',{staticClass:"t-header"},[_c('div',{staticClass:"t-header__inner"},[_c('div',{staticClass:"t-header__body"},[_c('div',{staticClass:"m-user"},[_c('a',{staticClass:"m-user__name a-accordion js-accordion",class:{'a-accordion': !_vm.showSignOut, 'a-accordion-t': _vm.showSignOut},on:{"click":function($event){_vm.showSignOut=!_vm.showSignOut}}},[_vm._v(_vm._s(_vm.accountId))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSignOut),expression:"showSignOut"}],staticClass:"m-menu__list--underlayer a-accordion__body"},[(_vm.login)?_c('a',{staticClass:"m-menu__link m-menu__link--icon",on:{"click":_vm.goSignOut}},[_vm._v("ログアウト")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"m-menu"},[_c('ul',{staticClass:"m-menu__list"},[_c('li',{staticClass:"m-menu__item"},[_c('a',{staticClass:"m-menu__link m-menu__link--icon js-accordion",class:{'a-accordion': !_vm.showConfiguration, 'a-accordion-t': _vm.showConfiguration},on:{"click":function($event){_vm.showConfiguration=!_vm.showConfiguration}}},[_c('span',{staticClass:"m-menu__icon a-icon--settings"},[_vm._v("設定")])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showConfiguration),expression:"showConfiguration"}],staticClass:"m-menu__list--underlayer a-accordion__body"},[_c('li',{staticClass:"m-menu__item"},[_c('router-link',{staticClass:"m-menu__link m-menu__link--icon",attrs:{"to":"/delivery/list-frame"}},[_vm._v("配信サービス")])],1),_vm._v(" "),_c('li',{staticClass:"m-menu__item"},[_c('router-link',{staticClass:"m-menu__link m-menu__link--icon",attrs:{"to":"/delivery/list-action"}},[_vm._v("アクション")])],1)])]),_vm._v(" "),_c('li',{staticClass:"m-menu__item"},[_c('a',{staticClass:"m-menu__link m-menu__link--icon js-accordion",class:{'a-accordion': !_vm.showManagement, 'a-accordion-t': _vm.showManagement},on:{"click":function($event){_vm.showManagement=!_vm.showManagement}}},[_c('span',{staticClass:"m-menu__icon a-icon--panel"},[_vm._v("管理")])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showManagement),expression:"showManagement"}],staticClass:"m-menu__list--underlayer a-accordion__body"},[_c('li',{staticClass:"m-menu__item"},[_c('router-link',{staticClass:"m-menu__link m-menu__link--icon",attrs:{"to":"/delivery/list-domain"}},[_vm._v("ドメイン設定")])],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"t-header__mask"}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('main',{staticClass:"t-main"},[_c('div',{staticClass:"a-section"},[_c('router-view')],1)]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"t-header__toggle"},[_c('span',{staticClass:"t-header__toggle-inner"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-service"},[_c('p',{staticClass:"m-service__logo"},[_vm._v("PDQ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("7sb+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/delivery/action/ListAction.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ListAction = ({
  name: 'listAction',
  data: function data() {
    var columns = { actionId: 'アクションID', name: 'アクション名', type: '種類', mtime: '作成日時', utime: '更新日時', delete: '削除' };
    return {
      listActionTitle: 'アクション一覧',
      columns: columns,
      searchQuery: ''
    };
  },
  created: function created() {
    stores.dispatch('checkSessionId');
    stores.dispatch('getActionListData');
  },

  // ajaxで取得してきた
  computed: {
    tasks: function tasks() {
      return stores.state.action.actionList;
    },
    filteredTasks: function filteredTasks() {
      if (!this.searchQuery) return this.tasks;
      var regexp = new RegExp(this.searchQuery, 'i');

      return this.tasks.filter(function (task) {
        return regexp.test(task.metadata.name);
      });
    }
  },
  methods: {
    callActionList: function callActionList() {
      stores.dispatch('actionList', this.tasks);
    },
    createActionLink: function createActionLink() {
      this.$router.push('/delivery/create-action');
    },
    deleteAction: function deleteAction(action) {
      if (confirm(action.actionId + 'のバージョン' + action.versionId + 'を削除しますか？')) {
        stores.dispatch('actionDelete', action);
      }
    }
  },
  filters: {
    moment: function moment(date) {
      return moment_default()(date).format('YYYY/MM/DD HH:mm');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683d3921","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/delivery/action/ListAction.vue
var ListAction_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listAction"},[_c('main',{staticClass:"t-main"},[_vm._m(0),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.listActionTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.createActionLink}},[_vm._v("新規登録")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("--絞り込み--\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"Filter..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"a-section"},[_c('table',{staticClass:"m-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.columns.name))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.type))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.mtime))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.utime))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.delete))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredTasks),function(task){return _c('tr',[_c('td',[_c('router-link',{attrs:{"to":{ path: 'update-action', query: { actionId: task.actionId}}}},[_vm._v(_vm._s(task.metadata.name)+"\n            ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(task["metadata"]["type"]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(task["mtime"])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(task["utime"])))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deleteAction(task)}}})])])}),0)])])])])}
var ListAction_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("アクション一覧")])])])}]
var ListAction_esExports = { render: ListAction_render, staticRenderFns: ListAction_staticRenderFns }
/* harmony default export */ var action_ListAction = (ListAction_esExports);
// CONCATENATED MODULE: ./src/components/delivery/action/ListAction.vue
var ListAction_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ListAction___vue_template_functional__ = false
/* styles */
var ListAction___vue_styles__ = null
/* scopeId */
var ListAction___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ListAction___vue_module_identifier__ = null
var ListAction_Component = ListAction_normalizeComponent(
  ListAction,
  action_ListAction,
  ListAction___vue_template_functional__,
  ListAction___vue_styles__,
  ListAction___vue_scopeId__,
  ListAction___vue_module_identifier__
)

/* harmony default export */ var delivery_action_ListAction = (ListAction_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/delivery/action/CreateAction.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var CreateAction = ({
  name: 'createAction',
  data: function data() {
    return {
      createActionTitle: 'アクション登録',
      actiontypes: actiontypes
    };
  },
  created: function created() {
    stores.dispatch('formatActionData');
    stores.dispatch('getScenarioList');
  },

  computed: {
    tasks: {
      get: function get() {
        return stores.state.action.action;
      }
    },
    scenarioList: {
      get: function get() {
        return stores.state.action.scenarioList;
      }
    },
    uploadedImage: {
      get: function get() {
        return stores.state.action.uploadedImage;
      }
    },
    // バリデーション関数を定義する
    validation: function validation() {
      return {
        actionId: regexp.test(this.tasks.actionId),
        name: !!this.tasks.metadata.name.trim(),
        actiontype: !!this.tasks.metadata.type.trim(),
        url: this.tasks.metadata.type === 'popup' && !!this.tasks.configuration.url.trim() || this.tasks.metadata.type === 'recommend-ai' || this.tasks.metadata.type === 'icon'
      };
    },
    // バリデーションを読み込む関数
    isValid: function isValid() {
      var msg = [];
      if (this.tasks.actionId === '') {
        msg.push('actionIdは必須です');
      } else if (this.validation.actionId === false) {
        msg.push('入力項目(actionId)に不備があります');
      }
      if (this.validation.name === false) {
        msg.push('タイトルは必須です');
      }
      if (this.validation.actionType === false) {
        msg.push('アクションタイプは必須です');
      }
      if (this.validation.url === false) {
        msg.push('URLは必須です');
      }
      if (this.tasks.configuration.type === 'recommend-ai') {
        if (this.tasks.configuration.scenarioId == null || this.tasks.configuration.scenarioId === '') {
          msg.push('scenarioIdは必須です');
        }
      }
      if (this.tasks.configuration.type !== 'recommend-ai' && (this.tasks.model == null || this.tasks.model === '')) {
        msg.push('画像は必須です');
      }
      if (this.tasks.configuration.type === 'popup' || this.tasks.configuration.type === 'icon') {
        if (this.tasks.configuration.positionConfiguration.width !== '' && numberRegexp.test(this.tasks.configuration.positionConfiguration.width) === false) {
          msg.push('表示位置設定（横方向）の数値に不備があります');
        }
        if (this.tasks.configuration.positionConfiguration.height !== '' && numberRegexp.test(this.tasks.configuration.positionConfiguration.height) === false) {
          msg.push('表示位置設定（縦方向）の数値に不備があります');
        }
      }
      if (this.tasks.configuration.type === 'popup') {
        if (this.tasks.configuration.size.width !== '' && (numberRegexp.test(this.tasks.configuration.size.width) === false || this.tasks.configuration.size.width < 1)) {
          msg.push('表示サイズ設定（幅）の数値に不備があります（1以上）');
        }
        if (this.tasks.configuration.size.height !== '' && (numberRegexp.test(this.tasks.configuration.size.height) === false || this.tasks.configuration.size.height < 1)) {
          msg.push('表示サイズ設定（高さ）の数値に不備があります（1以上）');
        }
      }
      return msg.join('\n');
    }
  },

  methods: {
    createAction: function createAction() {
      var errMsg = this.isValid;
      if (errMsg === '') {
        stores.dispatch('checkSessionId');
        stores.dispatch('createAction', this.$router);
      } else {
        alert(errMsg);
      }
    },
    goListAction: function goListAction() {
      this.$router.push('/delivery/list-action');
    },
    changeActionType: function changeActionType() {
      // configurationを初期化する。
      stores.dispatch('formatConfigurationData');
    },
    deleteImage: function deleteImage() {
      stores.dispatch('setModel', { 'model': '', 'modelExtention': '' });
      stores.dispatch('setUploadedImage', '');
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (files) {
        // base64に変換する
        var fileReader = new FileReader();
        fileReader.onload = function () {
          if (Object(lodash["includes"])(['png', 'jpg', 'jpeg', 'gif'], this.result.split(',')[0].split(';')[0].split('/')[1])) {
            var modelData = { 'model': this.result.split(',')[1], 'modelExtention': this.result.split(',')[0].split(':')[1].split('/')[1].split(';')[0] };
            stores.dispatch('setModel', modelData);
            stores.dispatch('setUploadedImage', this.result);
          } else {
            alert('画像ファイルは「jpg」「png」「gif」のみ登録可能です。');
            stores.dispatch('setModel', { 'model': '', 'modelExtention': '' });
            stores.dispatch('setUploadedImage', '');
          }
        };
        if (this.tasks.metadata.type === ICON) {
          if (files[0].size > UPLOAD_ICON_LIMITATION.LIMIT) {
            alert('アイコン画像は' + UPLOAD_ICON_LIMITATION.TEXT + '未満のサイズでのみ登録可能です。');
            stores.dispatch('setModel', { 'model': '', 'modelExtention': '' });
            stores.dispatch('setUploadedImage', '');
          } else {
            fileReader.readAsDataURL(files[0]);
            var img = void 0;
            img = new Image();
            img.onload = function () {
              if (this.width !== this.height) {
                alert('アイコン画像は縦横比が1:1の画像のみ登録可能です。');
                stores.dispatch('setModel', { 'model': '', 'modelExtention': '' });
                stores.dispatch('setUploadedImage', '');
              }
            };
            img.src = (window.URL || window.webkitURL).createObjectURL(files[0]);
          }
        } else if (this.tasks.metadata.type === POPUP) {
          if (files[0].size > UPLOAD_POPUP_LIMITATION.LIMIT) {
            alert('ポップアップ画像は' + UPLOAD_POPUP_LIMITATION.TEXT + '未満のサイズでのみ登録可能です。');
            stores.dispatch('setModel', { 'model': '', 'modelExtention': '' });
            stores.dispatch('setUploadedImage', '');
          } else {
            fileReader.readAsDataURL(files[0]);
          }
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e26781","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/delivery/action/CreateAction.vue
var CreateAction_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"createAction"},[_c('main',{staticClass:"t-main"},[_c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('router-link',{staticClass:"a-text a-link",attrs:{"to":"/delivery/list-action"}},[_vm._v("アクション一覧")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.createActionTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("actionId"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.actionId),expression:"tasks.actionId"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：test01"},domProps:{"value":(_vm.tasks.actionId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks, "actionId", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("タイトル"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.metadata.name),expression:"tasks.metadata.name"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：test"},domProps:{"value":(_vm.tasks.metadata.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.metadata, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("アクションタイプ"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.metadata.type),expression:"tasks.metadata.type"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.metadata, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.changeActionType]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.actiontypes),function(actiontype){return _c('option',{domProps:{"value":actiontype}},[_vm._v(_vm._s(actiontype))])})],2)])])])]),_vm._v(" "),(_vm.tasks.metadata.type==='popup')?_c('div',[_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("LINKURL"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.url),expression:"tasks.configuration.url"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：https://test.jp/test"},domProps:{"value":(_vm.tasks.configuration.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "url", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("バナー画像"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{staticClass:"m-form__input m-form__input--file",attrs:{"type":"file"},on:{"change":_vm.onFileChange}})])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadedImage),expression:"uploadedImage"}],attrs:{"src":_vm.uploadedImage,"width":"30%"}}),_vm._v(" "),(_vm.tasks.model!='')?_c('button',{staticClass:"m-form__delete",on:{"click":_vm.deleteImage}},[_vm._v("delete")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示位置設定（横方向）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("左右\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.widthType),expression:"tasks.configuration.positionConfiguration.widthType"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "widthType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"left"}},[_vm._v("left")]),_vm._v(" "),_c('option',{attrs:{"value":"right"}},[_vm._v("right")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.widthUnits),expression:"tasks.configuration.positionConfiguration.widthUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "widthUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.width),expression:"tasks.configuration.positionConfiguration.width"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"0","placeholder":"width"},domProps:{"value":(_vm.tasks.configuration.positionConfiguration.width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.positionConfiguration, "width", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示位置設定（縦方向）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("上下\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.heightType),expression:"tasks.configuration.positionConfiguration.heightType"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "heightType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"top"}},[_vm._v("top")]),_vm._v(" "),_c('option',{attrs:{"value":"bottom"}},[_vm._v("bottom")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.heightUnits),expression:"tasks.configuration.positionConfiguration.heightUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "heightUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.height),expression:"tasks.configuration.positionConfiguration.height"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"0","placeholder":"height"},domProps:{"value":(_vm.tasks.configuration.positionConfiguration.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.positionConfiguration, "height", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示サイズ設定（幅）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.size.widthUnits),expression:"tasks.configuration.size.widthUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.size, "widthUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.size.width),expression:"tasks.configuration.size.width"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"1","placeholder":"width"},domProps:{"value":(_vm.tasks.configuration.size.width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.size, "width", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示サイズ設定（高さ）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.size.heightUnits),expression:"tasks.configuration.size.heightUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.size, "heightUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.size.height),expression:"tasks.configuration.size.height"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"1","placeholder":"height"},domProps:{"value":(_vm.tasks.configuration.size.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.size, "height", $event.target.value)}}})])])]),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.createAction}},[_vm._v("登録")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.goListAction}},[_vm._v("キャンセル")])])]):_vm._e(),_vm._v(" "),(_vm.tasks.metadata.type==='recommend-ai')?_c('div',[_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("アクションで使用するシナリオのscenarioId"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.scenarioId),expression:"tasks.configuration.scenarioId"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration, "scenarioId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.scenarioList),function(scenario){return _c('option',{domProps:{"value":scenario.scenarioId}},[_vm._v(_vm._s(scenario.scenarioId))])})],2)])])])]),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.createAction}},[_vm._v("登録")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.goListAction}},[_vm._v("キャンセル")])])]):_vm._e(),_vm._v(" "),(_vm.tasks.metadata.type==='icon')?_c('div',[_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("アイコン画像"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{staticClass:"m-form__input m-form__input--file",attrs:{"type":"file"},on:{"change":_vm.onFileChange}})])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadedImage),expression:"uploadedImage"}],attrs:{"src":_vm.uploadedImage,"width":"30%"}}),_vm._v(" "),(_vm.tasks.model!='')?_c('button',{staticClass:"m-form__delete",on:{"click":_vm.deleteImage}},[_vm._v("delete")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示位置設定（横方向）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("左右\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.widthType),expression:"tasks.configuration.positionConfiguration.widthType"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "widthType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"left"}},[_vm._v("left")]),_vm._v(" "),_c('option',{attrs:{"value":"right"}},[_vm._v("right")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.widthUnits),expression:"tasks.configuration.positionConfiguration.widthUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "widthUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.width),expression:"tasks.configuration.positionConfiguration.width"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"0","placeholder":"width"},domProps:{"value":(_vm.tasks.configuration.positionConfiguration.width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.positionConfiguration, "width", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示位置設定（縦方向）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("上下\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.heightType),expression:"tasks.configuration.positionConfiguration.heightType"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "heightType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"top"}},[_vm._v("top")]),_vm._v(" "),_c('option',{attrs:{"value":"bottom"}},[_vm._v("bottom")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.heightUnits),expression:"tasks.configuration.positionConfiguration.heightUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "heightUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.height),expression:"tasks.configuration.positionConfiguration.height"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"0","placeholder":"height"},domProps:{"value":(_vm.tasks.configuration.positionConfiguration.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.positionConfiguration, "height", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("ボットスタイル設定")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("テキストカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textColor),expression:"tasks.configuration.textColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.textColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textColor),expression:"tasks.configuration.textColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.textColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.textColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textColor", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("テキストリンクカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textLinkColor),expression:"tasks.configuration.textLinkColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.textLinkColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textLinkColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textLinkColor),expression:"tasks.configuration.textLinkColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.textLinkColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.textLinkColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textLinkColor", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("吹き出しカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textBackground),expression:"tasks.configuration.textBackground"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.textBackground)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textBackground", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textBackground),expression:"tasks.configuration.textBackground"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.textBackground }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.textBackground)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textBackground", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("ユーザスタイル設定")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("テキストカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.userTextColor),expression:"tasks.configuration.userTextColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.userTextColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "userTextColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.userTextColor),expression:"tasks.configuration.userTextColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.userTextColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.userTextColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "userTextColor", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("吹き出しカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.userTextBackground),expression:"tasks.configuration.userTextBackground"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.userTextBackground)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "userTextBackground", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.userTextBackground),expression:"tasks.configuration.userTextBackground"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.userTextBackground }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.userTextBackground)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "userTextBackground", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("ボタンスタイル設定")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("ボタンカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonColor),expression:"tasks.configuration.buttonColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.buttonColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonColor),expression:"tasks.configuration.buttonColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.buttonColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.buttonColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonColor", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("テキストカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonTextColor),expression:"tasks.configuration.buttonTextColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.buttonTextColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonTextColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonTextColor),expression:"tasks.configuration.buttonTextColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.buttonTextColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.buttonTextColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonTextColor", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("ボタンエリアカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonAreaColor),expression:"tasks.configuration.buttonAreaColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.buttonAreaColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonAreaColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonAreaColor),expression:"tasks.configuration.buttonAreaColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.buttonAreaColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.buttonAreaColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonAreaColor", $event.target.value)}}})]),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.createAction}},[_vm._v("登録")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.goListAction}},[_vm._v("キャンセル")])])]):_vm._e()])])}
var CreateAction_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("アクション登録")])])}]
var CreateAction_esExports = { render: CreateAction_render, staticRenderFns: CreateAction_staticRenderFns }
/* harmony default export */ var action_CreateAction = (CreateAction_esExports);
// CONCATENATED MODULE: ./src/components/delivery/action/CreateAction.vue
var CreateAction_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateAction___vue_template_functional__ = false
/* styles */
var CreateAction___vue_styles__ = null
/* scopeId */
var CreateAction___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateAction___vue_module_identifier__ = null
var CreateAction_Component = CreateAction_normalizeComponent(
  CreateAction,
  action_CreateAction,
  CreateAction___vue_template_functional__,
  CreateAction___vue_styles__,
  CreateAction___vue_scopeId__,
  CreateAction___vue_module_identifier__
)

/* harmony default export */ var delivery_action_CreateAction = (CreateAction_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/delivery/action/UpdateAction.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var UpdateAction = ({
  name: 'updateAction',
  data: function data() {
    return { updateActionTitle: 'アクション編集', actiontypes: actiontypes };
  },
  created: function created() {
    stores.dispatch('checkSessionId');
    this.tasks.actionId = this.$route.query.actionId;
    stores.dispatch('getActionData');
    stores.dispatch('getScenarioList');
  },

  computed: {
    tasks: {
      get: function get() {
        return stores.state.action.action;
      }
    },
    scenarioList: {
      get: function get() {
        return stores.state.action.scenarioList;
      }
    },
    actionType: {
      get: function get() {
        return stores.state.action.action.metadata.type;
      }
    },
    uploadedImage: {
      get: function get() {
        return stores.state.action.uploadedImage;
      }
    },
    downloadUrl: {
      get: function get() {
        return stores.state.action.downloadUrl;
      }
    },
    // バリデーション関数を定義する
    upValidation: function upValidation() {
      return {
        actionId: regexp.test(this.tasks.actionId),
        name: !!this.tasks.metadata.name.trim(),
        actiontype: !!this.tasks.metadata.type.trim(),
        url: this.tasks.metadata.type === 'popup' && !!this.tasks.configuration.url.trim() || this.tasks.metadata.type === 'recommend-ai' || this.tasks.metadata.type === 'icon',
        model: modelRegexp.test(this.tasks.model) || this.tasks.model === ''
      };
    },
    // バリデーションを読み込む関数
    isUpValid: function isUpValid() {
      var msg = [];
      if (this.tasks.actionId === '') {
        msg.push('actionIdは必須です');
      } else if (this.upValidation.actionId === false) {
        msg.push('入力項目(actionId)に不備があります');
      }
      if (this.upValidation.name === false) {
        msg.push('タイトルは必須です');
      }
      if (this.upValidation.actionType === false) {
        msg.push('アクションタイプは必須です');
      }
      if (this.upValidation.url === false) {
        msg.push('URLは必須です');
      }
      if (this.tasks.configuration.type === 'recommend-ai') {
        if (this.tasks.configuration.scenarioId == null || this.tasks.configuration.scenarioId === '') {
          msg.push('scenarioIdは必須です');
        }
      }
      if (this.tasks.configuration.type === 'popup' || this.tasks.configuration.type === 'icon') {
        if (this.tasks.configuration.positionConfiguration.width !== '' && numberRegexp.test(this.tasks.configuration.positionConfiguration.width) === false) {
          msg.push('表示位置設定（横方向）の数値に不備があります');
        }
        if (this.tasks.configuration.positionConfiguration.height !== '' && numberRegexp.test(this.tasks.configuration.positionConfiguration.height) === false) {
          msg.push('表示位置設定（縦方向）の数値に不備があります');
        }
      }
      if (this.tasks.configuration.type === 'popup') {
        if (this.tasks.configuration.size.width !== '' && (numberRegexp.test(this.tasks.configuration.size.width) === false || this.tasks.configuration.size.width < 1)) {
          msg.push('表示サイズ設定（幅）の数値に不備があります（1以上）');
        }
        if (this.tasks.configuration.size.height !== '' && (numberRegexp.test(this.tasks.configuration.size.height) === false || this.tasks.configuration.size.height < 1)) {
          msg.push('表示サイズ設定（高さ）の数値に不備があります（1以上）');
        }
      }
      return msg.join('\n');
    }
  },
  methods: {
    callAction: function callAction() {
      stores.dispatch('action', this.tasks);
    },
    updateAction: function updateAction() {
      var errMsg = this.isUpValid;
      if (errMsg === '') {
        stores.dispatch('checkSessionId');
        stores.dispatch('updateAction', this.$router);
      } else {
        alert(errMsg);
      }
    },
    goListAction: function goListAction() {
      this.$router.push('/delivery/list-action');
    },
    changeActionType: function changeActionType() {
      // configurationを初期化する。
      stores.dispatch('formatConfigurationData');
    },
    deleteImage: function deleteImage() {
      stores.dispatch('setModel', { 'model': '', 'modelExtention': '' });
      stores.dispatch('setUploadedImage', '');
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (files) {
        // base64に変換する
        var fileReader = new FileReader();
        fileReader.onload = function () {
          if (Object(lodash["includes"])(['png', 'jpg', 'jpeg', 'gif'], this.result.split(',')[0].split(';')[0].split('/')[1])) {
            var modelData = { 'model': this.result.split(',')[1], 'modelExtention': this.result.split(',')[0].split(':')[1].split('/')[1].split(';')[0] };
            stores.dispatch('setModel', modelData);
            stores.dispatch('setUploadedImage', this.result);
          } else {
            alert('画像ファイルは「jpg」「png」「gif」のみ登録可能です。');
            stores.dispatch('setModel', { 'model': '', 'modelExtention': '' });
            stores.dispatch('setUploadedImage', '');
          }
        };
        if (this.tasks.metadata.type === ICON) {
          if (files[0].size > UPLOAD_ICON_LIMITATION.LIMIT) {
            alert('アイコン画像は' + UPLOAD_ICON_LIMITATION.TEXT + '未満のサイズでのみ登録可能です。');
            stores.dispatch('setModel', { 'model': '', 'modelExtention': '' });
            stores.dispatch('setUploadedImage', '');
          } else {
            fileReader.readAsDataURL(files[0]);
            var img = void 0;
            img = new Image();
            img.onload = function () {
              if (this.width !== this.height) {
                alert('アイコン画像は縦横比が1:1の画像のみ登録可能です。');
                stores.dispatch('setModel', { 'model': '', 'modelExtention': '' });
                stores.dispatch('setUploadedImage', '');
              }
            };
            img.src = (window.URL || window.webkitURL).createObjectURL(files[0]);
          }
        } else if (this.tasks.metadata.type === POPUP) {
          if (files[0].size > UPLOAD_POPUP_LIMITATION.LIMIT) {
            alert('ポップアップ画像は' + UPLOAD_POPUP_LIMITATION.TEXT + '未満のサイズでのみ登録可能です。');
            stores.dispatch('setModel', { 'model': '', 'modelExtention': '' });
            stores.dispatch('setUploadedImage', '');
          } else {
            fileReader.readAsDataURL(files[0]);
          }
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a3ad3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/delivery/action/UpdateAction.vue
var UpdateAction_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"updateAction"},[_c('main',{staticClass:"t-main"},[_c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('router-link',{staticClass:"a-text a-link",attrs:{"to":"/delivery/list-action"}},[_vm._v("アクション一覧")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.updateActionTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("タイトル"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.metadata.name),expression:"tasks.metadata.name"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：test"},domProps:{"value":(_vm.tasks.metadata.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.metadata, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("アクションタイプ"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v(_vm._s(_vm.actionType))])])])]),_vm._v(" "),(_vm.tasks.metadata.type==='popup')?_c('div',[_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("LINKURL"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.url),expression:"tasks.configuration.url"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：https://test.jp/test"},domProps:{"value":(_vm.tasks.configuration.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "url", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("バナー画像\n          "),_c('input',{staticClass:"m-form__input m-form__input--file",attrs:{"type":"file"},on:{"change":_vm.onFileChange}})])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadedImage),expression:"uploadedImage"}],attrs:{"src":_vm.uploadedImage,"width":"30%"}}),(_vm.tasks.model!='')?_c('button',{staticClass:"m-form__delete",on:{"click":_vm.deleteImage}},[_vm._v("delete")]):_vm._e(),_vm._v(" "),(_vm.tasks.model=='')?_c('img',{attrs:{"src":_vm.downloadUrl,"width":"30%"}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示位置設定（横方向）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("左右\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.widthType),expression:"tasks.configuration.positionConfiguration.widthType"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "widthType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"left"}},[_vm._v("left")]),_vm._v(" "),_c('option',{attrs:{"value":"right"}},[_vm._v("right")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.widthUnits),expression:"tasks.configuration.positionConfiguration.widthUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "widthUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.width),expression:"tasks.configuration.positionConfiguration.width"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"0","placeholder":"width"},domProps:{"value":(_vm.tasks.configuration.positionConfiguration.width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.positionConfiguration, "width", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示位置設定（縦方向）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("上下\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.heightType),expression:"tasks.configuration.positionConfiguration.heightType"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "heightType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"top"}},[_vm._v("top")]),_vm._v(" "),_c('option',{attrs:{"value":"bottom"}},[_vm._v("bottom")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.heightUnits),expression:"tasks.configuration.positionConfiguration.heightUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "heightUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.height),expression:"tasks.configuration.positionConfiguration.height"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"0","placeholder":"height"},domProps:{"value":(_vm.tasks.configuration.positionConfiguration.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.positionConfiguration, "height", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示サイズ設定（幅）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.size.widthUnits),expression:"tasks.configuration.size.widthUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.size, "widthUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.size.width),expression:"tasks.configuration.size.width"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"1","placeholder":"width"},domProps:{"value":(_vm.tasks.configuration.size.width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.size, "width", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示サイズ設定（高さ）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.size.heightUnits),expression:"tasks.configuration.size.heightUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.size, "heightUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.size.height),expression:"tasks.configuration.size.height"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"1","placeholder":"height"},domProps:{"value":(_vm.tasks.configuration.size.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.size, "height", $event.target.value)}}})])])]),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.updateAction}},[_vm._v("更新")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.goListAction}},[_vm._v("キャンセル")])])]):_vm._e(),_vm._v(" "),(_vm.tasks.metadata.type==='recommend-ai')?_c('div',[_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("アクションで使用するシナリオのscenarioId"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.scenarioId),expression:"tasks.configuration.scenarioId"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration, "scenarioId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.scenarioList),function(scenario){return _c('option',{domProps:{"value":scenario.scenarioId}},[_vm._v(_vm._s(scenario.scenarioId))])})],2)])])])]),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.updateAction}},[_vm._v("更新")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.goListAction}},[_vm._v("キャンセル")])])]):_vm._e(),_vm._v(" "),(_vm.tasks.metadata.type==='icon')?_c('div',[_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("アイコン画像\n          "),_c('input',{staticClass:"m-form__input m-form__input--file",attrs:{"type":"file"},on:{"change":_vm.onFileChange}})])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadedImage),expression:"uploadedImage"}],attrs:{"src":_vm.uploadedImage,"width":"30%"}}),(_vm.tasks.model!='')?_c('button',{staticClass:"m-form__delete",on:{"click":_vm.deleteImage}},[_vm._v("delete")]):_vm._e(),_vm._v(" "),(_vm.tasks.model=='')?_c('img',{attrs:{"src":_vm.downloadUrl,"width":"30%"}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示位置設定（横方向）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("左右\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.widthType),expression:"tasks.configuration.positionConfiguration.widthType"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "widthType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"left"}},[_vm._v("left")]),_vm._v(" "),_c('option',{attrs:{"value":"right"}},[_vm._v("right")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.widthUnits),expression:"tasks.configuration.positionConfiguration.widthUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "widthUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.width),expression:"tasks.configuration.positionConfiguration.width"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"0","placeholder":"width"},domProps:{"value":(_vm.tasks.configuration.positionConfiguration.width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.positionConfiguration, "width", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示位置設定（縦方向）")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("上下\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.heightType),expression:"tasks.configuration.positionConfiguration.heightType"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "heightType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"top"}},[_vm._v("top")]),_vm._v(" "),_c('option',{attrs:{"value":"bottom"}},[_vm._v("bottom")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("単位\n          "),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.heightUnits),expression:"tasks.configuration.positionConfiguration.heightUnits"}],staticClass:"m-form__input m-form__input--select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tasks.configuration.positionConfiguration, "heightUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_c('option',{attrs:{"value":"px"}},[_vm._v("px")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item"},[_c('label',{staticClass:"m-form__label"},[_vm._v("数値\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.positionConfiguration.height),expression:"tasks.configuration.positionConfiguration.height"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"0","placeholder":"height"},domProps:{"value":(_vm.tasks.configuration.positionConfiguration.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration.positionConfiguration, "height", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("ボットスタイル設定")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("テキストカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textColor),expression:"tasks.configuration.textColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.textColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textColor),expression:"tasks.configuration.textColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.textColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.textColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textColor", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("テキストリンクカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textLinkColor),expression:"tasks.configuration.textLinkColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.textLinkColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textLinkColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textLinkColor),expression:"tasks.configuration.textLinkColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.textLinkColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.textLinkColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textLinkColor", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("吹き出しカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textBackground),expression:"tasks.configuration.textBackground"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.textBackground)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textBackground", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.textBackground),expression:"tasks.configuration.textBackground"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.textBackground }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.textBackground)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "textBackground", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("ユーザスタイル設定")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("テキストカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.userTextColor),expression:"tasks.configuration.userTextColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.userTextColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "userTextColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.userTextColor),expression:"tasks.configuration.userTextColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.userTextColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.userTextColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "userTextColor", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("吹き出しカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.userTextBackground),expression:"tasks.configuration.userTextBackground"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.userTextBackground)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "userTextBackground", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.userTextBackground),expression:"tasks.configuration.userTextBackground"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.userTextBackground }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.userTextBackground)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "userTextBackground", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("ボタンスタイル設定")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("ボタンカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonColor),expression:"tasks.configuration.buttonColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.buttonColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonColor),expression:"tasks.configuration.buttonColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.buttonColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.buttonColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonColor", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("テキストカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonTextColor),expression:"tasks.configuration.buttonTextColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.buttonTextColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonTextColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonTextColor),expression:"tasks.configuration.buttonTextColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.buttonTextColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.buttonTextColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonTextColor", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--15"},[_c('label',{staticClass:"m-form__label"},[_vm._v("ボタンエリアカラー\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonAreaColor),expression:"tasks.configuration.buttonAreaColor"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：#111111"},domProps:{"value":(_vm.tasks.configuration.buttonAreaColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonAreaColor", $event.target.value)}}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.configuration.buttonAreaColor),expression:"tasks.configuration.buttonAreaColor"}],staticClass:"box",style:({ backgroundColor: _vm.tasks.configuration.buttonAreaColor }),attrs:{"type":"color"},domProps:{"value":(_vm.tasks.configuration.buttonAreaColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.configuration, "buttonAreaColor", $event.target.value)}}})]),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.updateAction}},[_vm._v("更新")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.goListAction}},[_vm._v("キャンセル")])])]):_vm._e()])])}
var UpdateAction_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("アクション編集")])])}]
var UpdateAction_esExports = { render: UpdateAction_render, staticRenderFns: UpdateAction_staticRenderFns }
/* harmony default export */ var action_UpdateAction = (UpdateAction_esExports);
// CONCATENATED MODULE: ./src/components/delivery/action/UpdateAction.vue
var UpdateAction_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UpdateAction___vue_template_functional__ = false
/* styles */
var UpdateAction___vue_styles__ = null
/* scopeId */
var UpdateAction___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UpdateAction___vue_module_identifier__ = null
var UpdateAction_Component = UpdateAction_normalizeComponent(
  UpdateAction,
  action_UpdateAction,
  UpdateAction___vue_template_functional__,
  UpdateAction___vue_styles__,
  UpdateAction___vue_scopeId__,
  UpdateAction___vue_module_identifier__
)

/* harmony default export */ var delivery_action_UpdateAction = (UpdateAction_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/delivery/domain/ListDomain.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ListDomain = ({
  name: 'listDomain',
  data: function data() {
    var columns = { fqdn: 'fqdn', mtime: '作成日時', utime: '更新日時', delete: '削除' };
    return { listDomainTitle: 'ドメイン一覧', columns: columns };
  },
  created: function created() {
    stores.dispatch('checkSessionId');
    stores.dispatch('getDomainListData');
  },

  // ajaxで取得してきた
  computed: { tasks: {
      get: function get() {
        return stores.state.domain.domainlist;
      }
    } },
  methods: {
    callDomainList: function callDomainList() {
      stores.dispatch('domainlist', this.tasks);
    },
    createDomainLink: function createDomainLink() {
      this.$router.push('/delivery/create-domain');
    },
    deleteDomain: function deleteDomain(domain) {
      if (confirm(domain.fqdn + 'のバージョン' + domain.versionId + 'を削除しますか？')) {
        stores.dispatch('domainDelete', domain);
      }
    }
  },
  filters: {
    moment: function moment(date) {
      return moment_default()(date).format('YYYY/MM/DD HH:mm');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d9669d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/delivery/domain/ListDomain.vue
var ListDomain_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listDomain"},[_c('main',{staticClass:"t-main"},[_vm._m(0),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.listDomainTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.createDomainLink}},[_vm._v("新規登録")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"a-section"},[_c('table',{staticClass:"m-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.columns.fqdn))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.mtime))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.utime))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.delete))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.tasks),function(task){return _c('tr',[_c('td',[_c('router-link',{attrs:{"to":{ path: 'update-domain', query: { fqdn: task.fqdn}}}},[_vm._v(_vm._s(task.fqdn))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(task["mtime"])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(task["utime"])))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deleteDomain(task)}}})])])}),0)])])])])}
var ListDomain_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("ドメイン一覧")])])])}]
var ListDomain_esExports = { render: ListDomain_render, staticRenderFns: ListDomain_staticRenderFns }
/* harmony default export */ var domain_ListDomain = (ListDomain_esExports);
// CONCATENATED MODULE: ./src/components/delivery/domain/ListDomain.vue
var ListDomain_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ListDomain___vue_template_functional__ = false
/* styles */
var ListDomain___vue_styles__ = null
/* scopeId */
var ListDomain___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ListDomain___vue_module_identifier__ = null
var ListDomain_Component = ListDomain_normalizeComponent(
  ListDomain,
  domain_ListDomain,
  ListDomain___vue_template_functional__,
  ListDomain___vue_styles__,
  ListDomain___vue_scopeId__,
  ListDomain___vue_module_identifier__
)

/* harmony default export */ var delivery_domain_ListDomain = (ListDomain_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/delivery/domain/CreateDomain.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var CreateDomain = ({
  name: 'createDomain',
  data: function data() {
    return {
      createDomainTitle: 'ドメイン登録'
    };
  },
  created: function created() {
    stores.dispatch('formatDomainData');
  },


  computed: {
    tasks: {
      get: function get() {
        return stores.state.domain.domain;
      }
    },
    // バリデーション関数を定義する
    validation: function validation() {
      return {
        fqdn: domainRegexp.test(this.tasks.fqdn)
      };
    },
    // バリデーションを読み込む関数
    isValid: function isValid() {
      var msg = [];
      if (this.tasks.fqdn === '') {
        msg.push('fqdnは必須です');
      } else if (Object(lodash["includes"])(this.validation, false) || this.tasks.fqdn.length > 150) {
        msg.push('入力項目に不備があります(150文字以内, e.g. example.com)');
      }
      return msg.join('\n');
    }
  },

  methods: {
    createdomain: function createdomain() {
      var errMsg = this.isValid;
      if (errMsg === '') {
        stores.dispatch('checkSessionId');
        stores.dispatch('createdomain', this.$router);
      } else {
        alert(errMsg);
      }
    },
    golistdomain: function golistdomain() {
      this.$router.push('/delivery/list-domain');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dc92f1d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/delivery/domain/CreateDomain.vue
var CreateDomain_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"createDomain"},[_c('main',{staticClass:"t-main"},[_c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('router-link',{staticClass:"a-text a-link",attrs:{"to":"/delivery/list-domain"}},[_vm._v("ドメイン一覧")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.createDomainTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("fqdn"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.fqdn),expression:"tasks.fqdn"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：example.com"},domProps:{"value":(_vm.tasks.fqdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks, "fqdn", $event.target.value)}}})])])]),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.createdomain}},[_vm._v("登録")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.golistdomain}},[_vm._v("キャンセル")])])])])}
var CreateDomain_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("ドメイン登録")])])}]
var CreateDomain_esExports = { render: CreateDomain_render, staticRenderFns: CreateDomain_staticRenderFns }
/* harmony default export */ var domain_CreateDomain = (CreateDomain_esExports);
// CONCATENATED MODULE: ./src/components/delivery/domain/CreateDomain.vue
var CreateDomain_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateDomain___vue_template_functional__ = false
/* styles */
var CreateDomain___vue_styles__ = null
/* scopeId */
var CreateDomain___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateDomain___vue_module_identifier__ = null
var CreateDomain_Component = CreateDomain_normalizeComponent(
  CreateDomain,
  domain_CreateDomain,
  CreateDomain___vue_template_functional__,
  CreateDomain___vue_styles__,
  CreateDomain___vue_scopeId__,
  CreateDomain___vue_module_identifier__
)

/* harmony default export */ var delivery_domain_CreateDomain = (CreateDomain_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/delivery/domain/UpdateDomain.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var UpdateDomain = ({
  name: 'updateDomain',
  data: function data() {
    return { updateDomainTitle: 'ドメイン編集' };
  },
  created: function created() {
    stores.dispatch('checkSessionId');
    stores.state.domain.domain.fqdn = this.$route.query.fqdn;
    stores.dispatch('getDomainData');
  },

  computed: {
    tasks: {
      get: function get() {
        return stores.state.domain.domain;
      }
    },
    // バリデーション関数を定義する
    upValidation: function upValidation() {
      return {
        fqdn: domainRegexp.test(this.tasks.fqdn)
      };
    },
    // バリデーションを読み込む関数
    isUpValid: function isUpValid() {
      var msg = [];
      if (this.tasks.fqdn == null || this.tasks.fqdn === '') {
        msg.push('fqdnは必須です');
      } else if (Object(lodash["includes"])(this.upValidation, false || this.tasks.fqdn.length > 150)) {
        msg.push('入力項目に不備があります(150文字以内, e.g. example.com)');
      }
      return msg.join('\n');
    }
  },
  methods: {
    callDomain: function callDomain() {
      stores.dispatch('domain', this.tasks);
    },
    updateDomain: function updateDomain() {
      var errMsg = this.isUpValid;
      if (errMsg === '') {
        stores.dispatch('checkSessionId');
        stores.dispatch('updateDomain', this.$router);
      } else {
        alert(errMsg);
      }
    },
    goListDomain: function goListDomain() {
      this.$router.push('/delivery/list-domain');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbef3280","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/delivery/domain/UpdateDomain.vue
var UpdateDomain_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"updateDomain"},[_c('main',{staticClass:"t-main"},[_c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('router-link',{staticClass:"a-text a-link",attrs:{"to":"/delivery/list-domain"}},[_vm._v("ドメイン一覧")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.updateDomainTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("fqdn"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※変更不可")]),_vm._v(" "),_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v(_vm._s(_vm.tasks.fqdn))])])])]),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.updateDomain}},[_vm._v("更新")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.goListDomain}},[_vm._v("キャンセル")])])])])}
var UpdateDomain_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("ドメイン編集")])])}]
var UpdateDomain_esExports = { render: UpdateDomain_render, staticRenderFns: UpdateDomain_staticRenderFns }
/* harmony default export */ var domain_UpdateDomain = (UpdateDomain_esExports);
// CONCATENATED MODULE: ./src/components/delivery/domain/UpdateDomain.vue
var UpdateDomain_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UpdateDomain___vue_template_functional__ = false
/* styles */
var UpdateDomain___vue_styles__ = null
/* scopeId */
var UpdateDomain___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UpdateDomain___vue_module_identifier__ = null
var UpdateDomain_Component = UpdateDomain_normalizeComponent(
  UpdateDomain,
  domain_UpdateDomain,
  UpdateDomain___vue_template_functional__,
  UpdateDomain___vue_styles__,
  UpdateDomain___vue_scopeId__,
  UpdateDomain___vue_module_identifier__
)

/* harmony default export */ var delivery_domain_UpdateDomain = (UpdateDomain_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/delivery/frame/ListFrame.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ListFrame = ({
  name: 'listFrame',
  data: function data() {
    var columns = { frameId: '枠ID', name: '枠名', mtime: '作成日時', utime: '更新日時', delete: '削除' };
    return {
      listFrameTitle: '枠一覧',
      columns: columns,
      fqdn: '',
      searchQuery: ''
    };
  },

  // 初回コンポーネント作成
  created: function created() {
    stores.dispatch('checkSessionId');
    stores.dispatch('getFrameListData', this.$route.query.fqdn);
    stores.dispatch('getDomainListData');
  },

  // ajaxで取得してきた
  computed: {
    tasks: function tasks() {
      return stores.state.frame.framelist;
    },
    domains: function domains() {
      return stores.state.frame.domainlist;
    },
    filteredTasks: function filteredTasks() {
      if (!this.searchQuery) return this.tasks;
      var regexp = new RegExp(this.searchQuery, 'i');

      return this.tasks.filter(function (task) {
        return regexp.test(task.metadata.name);
      });
    }
  },
  methods: {
    callframelist: function callframelist() {
      stores.dispatch('framelist', this.tasks);
    },
    createframelink: function createframelink() {
      this.$router.push('/delivery/create-frame?fqdn=' + this.fqdn);
    },
    changeDomain: function changeDomain() {
      // 選択ドメインの枠を呼び出す
      stores.dispatch('getFrameListData', this.fqdn);
      this.$router.push('/delivery/list-frame?fqdn=' + this.fqdn);
    },
    deleteFrame: function deleteFrame(frame) {
      if (confirm(frame.fqdn + 'に登録された' + frame.frameId + 'のバージョン' + frame.versionId + 'を削除しますか？')) {
        stores.dispatch('frameDelete', frame);
      }
    }
  },
  filters: {
    moment: function moment(date) {
      return moment_default()(date).format('YYYY/MM/DD HH:mm');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39fe38a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/delivery/frame/ListFrame.vue
var ListFrame_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listFrame"},[_c('main',{staticClass:"t-main"},[_vm._m(0),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.listFrameTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("fqdn"),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fqdn),expression:"fqdn"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fqdn=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeDomain]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.domains),function(domain){return _c('option',{domProps:{"value":domain.fqdn}},[_vm._v(_vm._s(domain.fqdn))])})],2)])])])]),_vm._v(" "),(_vm.fqdn)?_c('div',[_c('div',{staticClass:"m-form__item-wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.createframelink}},[_vm._v("新規登録")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("--絞り込み--\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"Filter..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"a-section"},[_c('table',{staticClass:"m-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.columns.name))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.mtime))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.utime))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.delete))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredTasks),function(task){return _c('tr',[_c('td',[_c('router-link',{attrs:{"to":{ path: 'get-frame', query: { frameId: task.frameId, fqdn: _vm.fqdn}}}},[_vm._v(_vm._s(task.metadata.name)+"\n              ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(task["mtime"])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(task["utime"])))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deleteFrame(task)}}})])])}),0)])])]):_vm._e()])])}
var ListFrame_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("枠一覧")])])])}]
var ListFrame_esExports = { render: ListFrame_render, staticRenderFns: ListFrame_staticRenderFns }
/* harmony default export */ var frame_ListFrame = (ListFrame_esExports);
// CONCATENATED MODULE: ./src/components/delivery/frame/ListFrame.vue
var ListFrame_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ListFrame___vue_template_functional__ = false
/* styles */
var ListFrame___vue_styles__ = null
/* scopeId */
var ListFrame___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ListFrame___vue_module_identifier__ = null
var ListFrame_Component = ListFrame_normalizeComponent(
  ListFrame,
  frame_ListFrame,
  ListFrame___vue_template_functional__,
  ListFrame___vue_styles__,
  ListFrame___vue_scopeId__,
  ListFrame___vue_module_identifier__
)

/* harmony default export */ var delivery_frame_ListFrame = (ListFrame_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/delivery/frame/GetFrame.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GetFrame = ({
  name: 'getFrame',
  data: function data() {
    return {
      getFrameTitle: '枠詳細',
      pageMode: pageMode,
      ruleList: ruleList,
      rulememoList: rulememoList,
      operatorList: operatorList,
      strOperatorList: strOperatorList,
      jpList: jpList,
      scopeList: scopeList,
      weekList: weekList,
      timezoneList: timezoneList,
      addRule: '',
      addAction: ''
    };
  },
  created: function created() {
    stores.dispatch('checkSessionId');
    stores.dispatch('getFrameData', { fqdn: this.$route.query.fqdn, frameId: this.$route.query.frameId });
  },


  computed: {
    tasks: {
      get: function get() {
        return stores.state.frame.frame;
      }
    },
    actionType: {
      get: function get() {
        return stores.state.frame.actionType;
      }
    },
    actionNames: {
      get: function get() {
        var actionNames = {};
        var actionList = stores.state.frame.actionList;
        for (var i = 0; i < actionList.length; i++) {
          actionNames[actionList[i].actionId] = actionList[i].metadata.name;
        }
        return actionNames;
      }
    }
  },

  methods: {
    callframe: function callframe() {
      stores.dispatch('frame', this.tasks);
    },
    goupdateframe: function goupdateframe() {
      this.$router.push('/delivery/update-frame?frameId=' + this.$route.query.frameId + '&fqdn=' + this.$route.query.fqdn);
    },
    golistframe: function golistframe() {
      this.$router.push('/delivery/list-frame');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cf358ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/delivery/frame/GetFrame.vue
var GetFrame_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"getFrame"},[_c('main',{staticClass:"t-main"},[_c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('router-link',{staticClass:"a-text a-link",attrs:{"to":"/delivery/list-frame"}},[_vm._v("枠一覧")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.getFrameTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("タイトル")]),_vm._v(" "),_c('a',{staticClass:"a-title a-title--sub a-text"},[_vm._v(_vm._s(_vm.tasks.metadata.name))])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("表示（非表示）ページ")]),_vm._v(" "),_c('label',{staticClass:"m-form__label"},[_vm._v("正規表現で設定\n        "),_c('ul',_vm._l((_vm.tasks.configuration.pages),function(list){return _c('li',{staticClass:"a-text"},[_c('a',{staticClass:"a-title a-title--sub a-text"},[_vm._v(_vm._s(list.pattern))]),_vm._v(" : "),_c('a',{staticClass:"a-title a-title--sub a-text"},[_vm._v(_vm._s(_vm.pageMode[list.mode]))])])}),0)])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("セグメント")]),_vm._v(" "),(_vm.tasks.configuration.segments.length==1)?_c('a',{staticClass:"a-title a-title--sub a-text"},[_vm._v(_vm._s(_vm.tasks.configuration.segments[0].segmentId))]):_vm._e()]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("アクション種別")]),_vm._v(" "),_c('a',{staticClass:"a-title a-title--sub a-text"},[_vm._v(_vm._s(_vm.actionType))])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("アクション設定")]),_vm._v(" "),_c('label',{staticClass:"m-form__label"},[_c('ul',_vm._l((_vm.tasks.configuration.actions),function(list){return _c('li',{staticClass:"a-text"},[_c('a',{staticClass:"a-title a-title--sub a-text"},[_vm._v(_vm._s(_vm.actionNames[list.actionId]))]),_vm._v("　　出現率："),_c('a',{staticClass:"a-title a-title--sub a-text"},[_vm._v(_vm._s(list.ratio)+"％")])])}),0)])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("ルール")]),_vm._v(" "),_c('label',{staticClass:"m-form__label"},[_c('ul',_vm._l((_vm.tasks.configuration.rules),function(list){return _c('li',{staticClass:"a-text"},[_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--40"},[_vm._v(_vm._s(_vm.ruleList[list.type]))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper m-form__item--60"},_vm._l((list),function(val,key){return _c('div',{staticClass:"m-form__item"},[(key!='type' && (key=='count' || key=='threashold' || key=='seconds'|| key=='interval'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(list[key]))])])]):_vm._e(),_vm._v(" "),(key!='type' && key=='operator' && (list.type=='visit-count' || list.type=='last-page-view' || list.type=='page-view-count' || list.type=='stay-seconds' || list.type=='view-page-path'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(_vm.jpList[list[key]]))])])]):_vm._e(),_vm._v(" "),(key!='type' && key=='operator' && list.type!='visit-count' && list.type!='last-page-view' && list.type!='page-view-count' && list.type!='stay-seconds' && list.type!='view-page-path')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(_vm.jpList[list[key]]))])])]):_vm._e(),_vm._v(" "),(key!='type' && key=='scope')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(_vm.jpList[list[key]]))])])]):_vm._e(),_vm._v(" "),(key!='type' && list.type=='referer' && key=='page')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("リファラ（ドメイン）\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(list[key]))])])]):_vm._e(),_vm._v(" "),(key!='type' && list.type=='user-os' && key=='value')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("OS名\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(list[key]))])])]):_vm._e(),_vm._v(" "),(key!='type' && list.type=='frequency' && key=='periodType')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(_vm.jpList[list[key]]))])])]):_vm._e(),_vm._v(" "),(key!='type' && list.type=='frequency' && key=='dayOfWeekThreshold' && list.periodType == 'week')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(_vm.jpList[list[key]]))])])]):_vm._e(),_vm._v(" "),(key!='type' && list.type=='frequency' && key=='minuteThreshold')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(list[key]))])])]):_vm._e(),_vm._v(" "),(key!='type' && list.type=='frequency' && key=='dayThreshold' && list.periodType == 'month')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(list[key]))])])]):_vm._e(),_vm._v(" "),(key!='type' && list.type=='frequency' && key=='hourThreshold' && (list.periodType == 'day' || list.periodType == 'month' || list.periodType == 'week'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(list[key]))])])]):_vm._e(),_vm._v(" "),(key!='type' && list.type!='referer' && list.type!='user-os' && (key=='page' || key=='page1' || key=='page2' || key=='page3' || key=='value' || key=='values' || key=='link'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(list[key]))])])]):_vm._e(),_vm._v(" "),(key=='timezone')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(list[key]))])])]):_vm._e(),_vm._v(" "),(key!='type' && (key=='start' || key=='end') && list.type!='day-period')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(list[key]))])])]):_vm._e(),_vm._v(" "),(key!='type' && (key=='start' || key=='end') && list.type=='day-period')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])+"\n                    "),_c('p',[_c('a',{staticClass:"a-text"},[_vm._v(_vm._s(list[key]))])])]):_vm._e()])}),0)])])}),0)])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.goupdateframe}},[_vm._v("枠編集画面へ")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.golistframe}},[_vm._v("戻る")])])])])}
var GetFrame_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("枠詳細")])])}]
var GetFrame_esExports = { render: GetFrame_render, staticRenderFns: GetFrame_staticRenderFns }
/* harmony default export */ var frame_GetFrame = (GetFrame_esExports);
// CONCATENATED MODULE: ./src/components/delivery/frame/GetFrame.vue
var GetFrame_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GetFrame___vue_template_functional__ = false
/* styles */
var GetFrame___vue_styles__ = null
/* scopeId */
var GetFrame___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GetFrame___vue_module_identifier__ = null
var GetFrame_Component = GetFrame_normalizeComponent(
  GetFrame,
  frame_GetFrame,
  GetFrame___vue_template_functional__,
  GetFrame___vue_styles__,
  GetFrame___vue_scopeId__,
  GetFrame___vue_module_identifier__
)

/* harmony default export */ var delivery_frame_GetFrame = (GetFrame_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/delivery/frame/CreateFrame.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var CreateFrame = ({
  name: 'createFrame',
  data: function data() {
    return {
      createFrameTitle: '枠登録',
      pageMode: pageMode,
      ruleList: ruleList,
      categoryList: categoryList,
      selectCategory: '',
      rulememoList: rulememoList,
      operatorList: operatorList,
      strOperatorList: strOperatorList,
      jpList: jpList,
      scopeList: scopeList,
      weekList: weekList,
      addRule: '',
      addAction: '',
      actionType: 'popup',
      actiontypes: actiontypes,
      selectRuleList: [],
      categoryRuleList: categoryRuleList,
      timezoneList: timezoneList,
      periodTypeList: periodTypeList,
      dayOfWeekList: dayOfWeekList,
      dayList: dayList,
      hourList: hourList,
      minuteList: minuteList
    };
  },
  created: function created() {
    stores.dispatch('getActionList', this.actionType);
    stores.dispatch('getSegmentList', this.segmentList);
    stores.dispatch('formatFrameData', this.$route.query.fqdn);
  },


  computed: {
    tasks: {
      get: function get() {
        return stores.state.frame.frame;
      }
    },
    actionNames: {
      get: function get() {
        var actionNames = {};
        var actionList = stores.state.frame.actionList;
        for (var i = 0; i < actionList.length; i++) {
          actionNames[actionList[i].actionId] = actionList[i].metadata.name;
        }
        return actionNames;
      }
    },
    actionList: {
      get: function get() {
        return stores.state.frame.actionList;
      }
    },
    nonRatio: {
      get: function get() {
        return stores.state.frame.nonRatio;
      }
    },
    segmentList: {
      get: function get() {
        return stores.state.frame.segmentList;
      }
    },
    // バリデーション関数を定義する
    validation: function validation() {
      return {
        fqdn: regexp.test(this.tasks.fqdn), // fqdn
        frameId: regexp.test(this.tasks.frameId), // frameId
        name: !!this.tasks.metadata.name.trim(), // name
        pages: this.checkPages, // pages
        actions: this.checkActions, // actions
        segments: this.checkSegments, // segments
        rules: this.checkRules // rules
      };
    },
    // バリデーションを読み込む関数
    isValid: function isValid() {
      var msg = [];
      if (this.tasks.frameId === '') {
        msg.push('frameIdは必須です');
      } else if (this.validation.frameId === false) {
        msg.push('入力項目(frameId)に不備があります');
      }
      if (this.validation.name === false) {
        msg.push('タイトルは必須です');
      }
      msg = msg.concat(this.validation.pages);
      msg = msg.concat(this.validation.actions);
      msg = msg.concat(this.validation.rules);
      return msg.join('\n');
    },
    checkPages: function checkPages() {
      var pagesMsg = [];
      for (var i = 0; i < this.tasks.configuration.pages.length; i++) {
        // 空白チェック
        if (this.tasks.configuration.pages[i].pattern === '') {
          pagesMsg.push('表示（非表示）ページ[' + (i + 1) + ']:ドメイン下のパスは必須です');
        } else if (pageNgRegexp.test(this.tasks.configuration.pages[i].pattern) === true) {
          pagesMsg.push('表示（非表示）ページ[' + (i + 1) + ']:ドメイン下のパスに不備があります');
        }
        if (this.tasks.configuration.pages[i].mode === '') {
          pagesMsg.push('表示（非表示）ページ[' + (i + 1) + ']:modeは必須です');
        }
        // TODO:被りはバリデーションにないが、可能なら今後チェックにつける
      }
      return pagesMsg;
    },
    checkActions: function checkActions() {
      var ratioSum = Number(this.nonRatio);
      var actionMsg = [];

      // 重複チェック
      var noDuplicate = Object(lodash["uniqBy"])(this.tasks.configuration.actions, 'actionId');
      if (this.tasks.configuration.actions.length !== noDuplicate.length) {
        actionMsg.push('アクションが重複しています');
      }

      for (var i = 0; i < this.tasks.configuration.actions.length; i++) {
        // 空白チェック
        if (this.tasks.configuration.actions[i].ratio === '') {
          actionMsg.push('アクション[' + (i + 1) + ']:出現率は必須です');
        } else if (this.tasks.configuration.actions[i].ratio < 1 || this.tasks.configuration.actions[i].ratio > 100) {
          actionMsg.push('アクション[' + (i + 1) + ']:出現率に不備があります(1~100)');
        }
        ratioSum = ratioSum + Number(this.tasks.configuration.actions[i].ratio);
        // TODO:被りとアクションTypeの一致判定はバリデーションにないが、可能なら今後チェックにつける
      }
      // 比率の合計は1になっていること
      if (ratioSum !== 100) {
        actionMsg.push('比率の合計は1になっていません');
      }
      return actionMsg;
    },

    checkSegments: function checkSegments() {
      var segmentMsg = [];
      if (this.tasks.configuration.segments.length > 1) {
        segmentMsg.push('セグメントの複数指定は対応していません');
      }
      return segmentMsg;
    },

    checkRules: function checkRules(rule) {
      var ruleMsg = [];
      for (var i = 0; i < this.tasks.configuration.rules.length; i++) {
        // パターン別にバリデーションをかける
        switch (this.tasks.configuration.rules[i].type) {
          case 'visit-count':
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(訪問回数:count)に不備があります');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(訪問回数:operator)に不備があります');
            }
            break;
          case 'last-page-view':
            if (!!this.tasks.configuration.rules[i].threashold.trim() === false) {
              ruleMsg.push('最後のページビュー日時:threasholdは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(最後のページビュー日時:operator)に不備があります');
            }
            break;
          case 'page-view-count':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(ページビュー数:scope)に不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(ページビュー数:count)に不備があります');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(ページビュー数:operator)に不備があります');
            }
            break;
          case 'stay-seconds':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(滞在秒数:scope)に不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].seconds) === false) {
              ruleMsg.push('入力項目(滞在秒数:seconds)に不備があります');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(滞在秒数:operator)に不備があります');
            }
            break;
          case 'view-page-path':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(閲覧ページのパス:scope)に不備があります');
            }
            if (!!this.tasks.configuration.rules[i].page.trim() === false) {
              ruleMsg.push('閲覧ページのパス:pageは必須です');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(閲覧ページのパス:count)に不備があります');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(閲覧ページのパス:operator)に不備があります');
            }
            break;
          case 'last-page-path':
            if (!!this.tasks.configuration.rules[i].page.trim() === false) {
              ruleMsg.push('最後の閲覧ページのパス:pageは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(最後の閲覧ページのパス:operator)に不備があります');
            }
            break;
          case 'walk-3pages':
            if (!!this.tasks.configuration.rules[i].page1.trim() === false) {
              ruleMsg.push('3階層ページ遷移閲覧シナリオ:page1は必須です');
            }
            if (!!this.tasks.configuration.rules[i].page2.trim() === false) {
              ruleMsg.push('3階層ページ遷移閲覧シナリオ:page2は必須です');
            }
            if (!!this.tasks.configuration.rules[i].page3.trim() === false) {
              ruleMsg.push('3階層ページ遷移閲覧シナリオ:page3は必須です');
            }
            break;
          case 'referer':
            if (!!this.tasks.configuration.rules[i].page.trim() === false) {
              ruleMsg.push('リンク元ページ（リファラ）のホスト:pageは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(リンク元ページ（リファラ）のホスト:operator)に不備があります');
            }
            break;
          case 'utm-source':
            if (!!this.tasks.configuration.rules[i].value.trim() === false) {
              ruleMsg.push('閲覧ページのクエリキー（utm_source）:valueは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(閲覧ページのクエリキー（utm_source）:operator)に不備があります');
            }
            break;
          case 'src-link-path':
            if (!!this.tasks.configuration.rules[i].link.trim() === false) {
              ruleMsg.push('サイト内のリンク元ページのパス:linkは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(サイト内のリンク元ページのパス:operator)に不備があります');
            }
            break;
          case 'user-os':
            if (!!this.tasks.configuration.rules[i].value.trim() === false) {
              ruleMsg.push('アクセス時のOS名:valueは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(アクセス時のOS名:operator)に不備があります');
            }
            break;
          case 'stop-view-count':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(配信回数上限で配信を停止:scope)に不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(配信回数上限で配信を停止:count)に不備があります');
            }
            break;
          case 'stop-close-count':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(閉じられた回数で配信を停止:scope)に不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(閉じられた回数で配信を停止:count)に不備があります');
            }
            break;
          case 'stop-click-count':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(クリック回数で配信を停止:scope)に不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(クリック回数で配信を停止:count)に不備があります');
            }
            break;
          case 'day-period':
            if (!!this.tasks.configuration.rules[i].start.trim() === false) {
              ruleMsg.push('期間:startは必須です');
            }
            if (!!this.tasks.configuration.rules[i].end.trim() === false) {
              ruleMsg.push('期間:endは必須です');
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('期間:timezoneは必須です');
            }
            break;
          case 'day-of-week':
            var weekFlg = true;
            if (!Array.isArray(this.tasks.configuration.rules[i].values)) {
              this.tasks.configuration.rules[i].values = this.tasks.configuration.rules[i].values.split(',');
            }
            for (var t = 0; t < this.tasks.configuration.rules[i].values.length; t++) {
              if (!Object(lodash["includes"])(weekList, this.tasks.configuration.rules[i].values[t])) {
                weekFlg = false;
              }
            }
            if (!weekFlg) {
              ruleMsg.push('入力項目(曜日:value)に不備があります');
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('曜日:timezoneは必須です');
            }
            break;
          case 'day-time':
            if (!!this.tasks.configuration.rules[i].start.trim() === false) {
              ruleMsg.push('時間:startは必須です');
            }
            if (!!this.tasks.configuration.rules[i].end.trim() === false) {
              ruleMsg.push('時間:endは必須です');
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('時間:timezoneは必須です');
            }
            break;
          case 'frequency':
            if (!Object(lodash["includes"])(periodTypeList, this.tasks.configuration.rules[i].periodType)) {
              ruleMsg.push('頻度:periodTypeは必須です');
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('頻度:timezoneは必須です');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].interval) === false) {
              ruleMsg.push('頻度:intervalは必須です');
            }
            if (!Object(lodash["includes"])(minuteList, this.tasks.configuration.rules[i].minuteThreshold)) {
              ruleMsg.push('頻度:minuteThresholdは必須です');
            }
            if (!Object(lodash["includes"])(hourList, this.tasks.configuration.rules[i].hourThreshold) && (this.tasks.configuration.rules[i].periodType === 'week' || this.tasks.configuration.rules[i].periodType === 'month' || this.tasks.configuration.rules[i].periodType === 'day')) {
              ruleMsg.push('頻度:hourThresholdは必須です');
            }
            if (!Object(lodash["includes"])(dayOfWeekList, this.tasks.configuration.rules[i].dayOfWeekThreshold) && this.tasks.configuration.rules[i].periodType === 'week') {
              ruleMsg.push('頻度:dayOfWeekThresholdは必須です');
            }
            if (!Object(lodash["includes"])(dayList, this.tasks.configuration.rules[i].dayThreshold) && this.tasks.configuration.rules[i].periodType === 'month') {
              ruleMsg.push('頻度:dayThresholdは必須です');
            }
            break;
          case 'user-view-limit':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('配信数上限:scopeに不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('配信数上限:countに不備があります');
            }
            break;
          case 'unknow':
            break;
        }
      }
      return ruleMsg;
    }
  },

  methods: {
    createFrame: function createFrame() {
      var errMsg = this.isValid;
      if (errMsg === '') {
        stores.dispatch('checkSessionId');
        stores.dispatch('createFrame', this.$router);
      } else {
        alert(errMsg);
      }
    },
    goListFrame: function goListFrame() {
      this.$router.push('/delivery/list-frame');
    },
    // ページリストから選択したページを削除する
    deletePage: function deletePage(list) {
      this.tasks.configuration.pages.splice(this.tasks.configuration.pages.indexOf(list), 1);
    },
    // アクションリストから選択したアクションを削除する
    deleteAction: function deleteAction(list) {
      this.tasks.configuration.actions.splice(this.tasks.configuration.actions.indexOf(list), 1);
      stores.dispatch('ratioChange');
    },
    // セグメントリストから選択したセグメントを削除する
    deleteSegment: function deleteSegment(list) {
      this.tasks.configuration.segments.splice(this.tasks.configuration.segments.indexOf(list), 1);
      this.segment = '';
    },
    // ルールリストから選択したルールを削除する
    deleteRule: function deleteRule(list) {
      this.tasks.configuration.rules.splice(this.tasks.configuration.rules.indexOf(list), 1);
    },
    // ページを追加する
    createPage: function createPage() {
      this.tasks.configuration.pages.push({ pattern: '', mode: '' });
    },
    // アクションを追加する
    addActionThing: function addActionThing(addAction) {
      var actionIds = this.tasks.configuration.actions.map(function (value) {
        return value.actionId;
      });
      if (actionIds.length > 0 && actionIds.indexOf(addAction) >= 0) {
        alert(this.actionNames[addAction] + 'は存在します');
      } else {
        this.tasks.configuration.actions.push({ actionId: addAction, ratio: '' });
      }
      this.addAction = '';
    },
    // セグメントを追加する
    addSegmentThing: function addSegmentThing(addSegment) {
      this.tasks.configuration.segments.push({ segmentId: addSegment });
    },
    // アクション種別を変更したら追加可能なアクションリストを更新する
    selectActionType: function selectActionType(actionType) {
      stores.dispatch('getActionList', actionType);
      this.addAction = '';
    },
    // ルールを追加する
    addRuleThing: function addRuleThing(addRule) {
      this.tasks.configuration.rules.push(Object(lodash["cloneDeep"])(ruleFormatList[addRule]));
      this.addRule = '';
      this.selectRuleList = '';
      this.selectCategory = '';
    },
    ratioChange: function ratioChange() {
      stores.dispatch('ratioChange');
    },
    selectRuleCategory: function selectRuleCategory(selectCategory) {
      this.selectRuleList = categoryRuleList[selectCategory];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-562a444b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/delivery/frame/CreateFrame.vue
var CreateFrame_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"createFrame"},[_c('main',{staticClass:"t-main"},[_c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('router-link',{staticClass:"a-text a-link",attrs:{"to":"/delivery/list-frame"}},[_vm._v("枠一覧")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.createFrameTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("frameId")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("frameIdを入力してください"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.frameId),expression:"tasks.frameId"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：test01"},domProps:{"value":(_vm.tasks.frameId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks, "frameId", $event.target.value)}}})])])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("タイトル")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("タイトルを入力してください"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.metadata.name),expression:"tasks.metadata.name"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：test"},domProps:{"value":(_vm.tasks.metadata.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.metadata, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示（非表示）ページ")]),_vm._v(" "),_vm._l((_vm.tasks.configuration.pages),function(list){return _c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("ドメイン下のパスを正規表現で指定できます"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list.pattern),expression:"list.pattern"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：/contents/*"},domProps:{"value":(list.pattern)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, "pattern", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--30"},[_c('label',{staticClass:"m-form__label"},[_vm._v("mode（表示・非表示）"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(list.mode),expression:"list.mode"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.pageMode),function(val,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(val))])})],2)])])]),_vm._v(" "),_c('button',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deletePage(list)}}},[_vm._v("delete")])])}),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button a-button--danger",on:{"click":_vm.createPage}},[_vm._v("表示（非表示）ページを追加する")])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("セグメント")]),_vm._v(" "),(_vm.tasks.configuration.segments=='')?_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("セグメント登録"),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.segment),expression:"segment"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.segment=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.addSegmentThing(_vm.segment)}]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.segmentList),function(Segment){return _c('option',{domProps:{"value":Segment.segmentId}},[_vm._v(_vm._s(Segment.metadata.name))])})],2)])])]):_vm._e(),_vm._v(" "),(_vm.tasks.configuration.segments!='')?_c('label',{staticClass:"m-form__label"},[_vm._v("セグメントを空にすると、指定セグメントの変更ができます\n       "),_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v(_vm._s(_vm.tasks.configuration.segments[0].segmentId))])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deleteSegment(_vm.tasks.configuration.segments[0])}}},[_vm._v("delete")])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("アクション種別")]),_vm._v(" "),(_vm.tasks.configuration.actions=='')?_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("アクション種別"),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.actionType),expression:"actionType"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.actionType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.selectActionType(_vm.actionType)}]}},_vm._l((_vm.actiontypes),function(actiontype){return _c('option',{domProps:{"value":actiontype}},[_vm._v(_vm._s(actiontype))])}),0)])])]):_vm._e(),_vm._v(" "),(_vm.tasks.configuration.actions!='')?_c('label',{staticClass:"m-form__label"},[_vm._v("アクション設定を空にすると、アクション種別の変更ができます\n       "),_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v(_vm._s(_vm.actionType))])]):_vm._e()]),_vm._v(" "),_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("アクション設定")]),_vm._v(" "),_vm._l((_vm.tasks.configuration.actions),function(list){return _c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v(_vm._s(_vm.actionNames[list.actionId]))]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("出現率"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list.ratio),expression:"list.ratio"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","step":"1","max":"100","min":"1","placeholder":"パーセント"},domProps:{"value":(list.ratio)},on:{"change":function($event){return _vm.ratioChange()},"input":function($event){if($event.target.composing){ return; }_vm.$set(list, "ratio", $event.target.value)}}})])]),_vm._v(" "),_c('button',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deleteAction(list)}}},[_vm._v("delete")])])}),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--50"},[_vm._v("アクションを実行しない比率　"+_vm._s(_vm.nonRatio))])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("右タブからアクションを追加できます")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--30"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAction),expression:"addAction"}],staticClass:"m-form__input m-form__input--select m-form__item--20",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.addAction=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.addActionThing(_vm.addAction)}]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.actionList),function(action){return _c('option',{domProps:{"value":action.actionId}},[_vm._v(_vm._s(action.metadata.name))])})],2)])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("ルール")]),_vm._v(" "),_vm._l((_vm.tasks.configuration.rules),function(list){return _c('div',[_c('div',{staticClass:"m-form__item-wrapper"},[_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.rulememoList[list.type])+"\n        "),_c('h2',{staticClass:"a-title a-title--sub m-form__item--100"},[_vm._v(_vm._s(_vm.ruleList[list.type]))])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_vm._l((list),function(val,key){return _c('div',{staticClass:"m-form__item"},[(key!='type' && (key=='count' || key=='threashold' || key=='seconds'|| key=='interval'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"1"},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e(),_vm._v(" "),(key!='type' && key=='operator' && (list.type=='visit-count' || list.type=='last-page-view' || list.type=='page-view-count' || list.type=='stay-seconds' || list.type=='view-page-path'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.operatorList),function(operator){return _c('option',{domProps:{"value":operator}},[_vm._v(_vm._s(_vm.jpList[operator]))])})],2)]):_vm._e(),_vm._v(" "),(key!='type' && key=='operator' && list.type!='visit-count' && list.type!='last-page-view' && list.type!='page-view-count' && list.type!='stay-seconds' && list.type!='view-page-path')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.strOperatorList),function(operator){return _c('option',{domProps:{"value":operator}},[_vm._v(_vm._s(_vm.jpList[operator]))])})],2)]):_vm._e(),_vm._v(" "),(key!='type' && key=='scope')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.scopeList),function(scope){return _c('option',{domProps:{"value":scope}},[_vm._v(_vm._s(_vm.jpList[scope]))])})],2)]):_vm._e(),_vm._v(" "),(key!='type' && list.type=='referer' && key=='page')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("リファラ（ドメイン）"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":""},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e(),_vm._v(" "),(key!='type' && list.type=='user-os' && key=='value')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("OS名"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":""},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e(),_vm._v(" "),(key!='type' && list.type!='referer' && list.type!='user-os' && (key=='page' || key=='page1' || key=='page2' || key=='page3' || key=='value' || key=='values' || key=='link'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":""},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e(),_vm._v(" "),(key=='timezone')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n         "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.timezoneList),function(val,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(val))])})],2)]):_vm._e(),_vm._v(" "),(key=='periodType')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n          "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.periodTypeList),function(val){return _c('option',{domProps:{"value":val}},[_vm._v(_vm._s(_vm.jpList[val]))])})],2)]):_vm._e(),_vm._v(" "),(key=='dayOfWeekThreshold' && list.periodType == 'week')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n          "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.dayOfWeekList),function(val){return _c('option',{domProps:{"value":val}},[_vm._v(_vm._s(_vm.jpList[val]))])})],2)]):_vm._e(),_vm._v(" "),(list.type=='frequency' && key=='minuteThreshold')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n         "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.minuteList),function(val){return _c('option',{domProps:{"value":val}},[_vm._v(_vm._s(val))])})],2)]):_vm._e(),_vm._v(" "),(list.type=='frequency' && key=='dayThreshold' && list.periodType == 'month')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n         "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.dayList),function(val){return _c('option',{domProps:{"value":val}},[_vm._v(_vm._s(val))])})],2)]):_vm._e(),_vm._v(" "),(list.type=='frequency' && key=='hourThreshold' && (list.periodType == 'day' || list.periodType == 'month' || list.periodType == 'week'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n         "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.hourList),function(val){return _c('option',{domProps:{"value":val}},[_vm._v(_vm._s(val))])})],2)]):_vm._e(),_vm._v(" "),(key!='type' && (key=='start' || key=='end') && list.type!='day-period')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"time"},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e(),_vm._v(" "),(key!='type' && (key=='start' || key=='end') && list.type=='day-period')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"datetime-local"},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e()])}),_vm._v(" "),_c('button',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deleteRule(list)}}},[_vm._v("delete")])],2)])}),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--25"},[_vm._v("右タブからルールを追加できます")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--30"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectCategory),expression:"selectCategory"}],staticClass:"m-form__input m-form__input--select m-form__item--20",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.selectRuleCategory(_vm.selectCategory)}]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.categoryList),function(val,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(val))])})],2)]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--30"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.addRule),expression:"addRule"}],staticClass:"m-form__input m-form__input--select m-form__item--20",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.addRule=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.addRuleThing(_vm.addRule)}]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.selectRuleList),function(val,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(val))])})],2)])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.createFrame}},[_vm._v("登録")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.goListFrame}},[_vm._v("枠一覧画面に戻る")])])],2)])}
var CreateFrame_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("枠登録")])])}]
var CreateFrame_esExports = { render: CreateFrame_render, staticRenderFns: CreateFrame_staticRenderFns }
/* harmony default export */ var frame_CreateFrame = (CreateFrame_esExports);
// CONCATENATED MODULE: ./src/components/delivery/frame/CreateFrame.vue
var CreateFrame_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateFrame___vue_template_functional__ = false
/* styles */
var CreateFrame___vue_styles__ = null
/* scopeId */
var CreateFrame___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateFrame___vue_module_identifier__ = null
var CreateFrame_Component = CreateFrame_normalizeComponent(
  CreateFrame,
  frame_CreateFrame,
  CreateFrame___vue_template_functional__,
  CreateFrame___vue_styles__,
  CreateFrame___vue_scopeId__,
  CreateFrame___vue_module_identifier__
)

/* harmony default export */ var delivery_frame_CreateFrame = (CreateFrame_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/delivery/frame/UpdateFrame.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var UpdateFrame = ({
  name: 'updateFrame',
  data: function data() {
    return {
      updateFrameTitle: '枠編集',
      pageMode: pageMode,
      ruleList: ruleList,
      categoryList: categoryList,
      selectCategory: '',
      rulememoList: rulememoList,
      operatorList: operatorList,
      strOperatorList: strOperatorList,
      jpList: jpList,
      scopeList: scopeList,
      weekList: weekList,
      addRule: '',
      addAction: '',
      selectRuleList: [],
      categoryRuleList: categoryRuleList,
      timezoneList: timezoneList,
      periodTypeList: periodTypeList,
      dayOfWeekList: dayOfWeekList,
      dayList: dayList,
      hourList: hourList,
      minuteList: minuteList
    };
  },
  created: function created() {
    stores.dispatch('checkSessionId');
    stores.dispatch('getSegmentList', this.segmentList);
    stores.dispatch('getFrameData', { fqdn: this.$route.query.fqdn, frameId: this.$route.query.frameId });
    stores.dispatch('getActionList', this.actionType);
  },

  computed: {
    tasks: {
      get: function get() {
        return stores.state.frame.frame;
      }
    },
    actionNames: {
      get: function get() {
        var actionNames = {};
        var actionList = stores.state.frame.actionList;
        for (var i = 0; i < actionList.length; i++) {
          actionNames[actionList[i].actionId] = actionList[i].metadata.name;
        }
        return actionNames;
      }
    },
    actionList: {
      get: function get() {
        return stores.state.frame.actionList;
      }
    },
    nonRatio: {
      get: function get() {
        return stores.state.frame.nonRatio;
      }
    },
    actionType: {
      get: function get() {
        return stores.state.frame.actionType;
      }
    },
    segmentList: {
      get: function get() {
        return stores.state.frame.segmentList;
      }
    },
    // バリデーション関数を定義する
    upValidation: function upValidation() {
      return {
        fqdn: regexp.test(this.tasks.fqdn), // fqdn
        frameId: regexp.test(this.tasks.frameId), // frameId
        name: !!this.tasks.metadata.name.trim(), // name
        pages: this.checkPages, // pages
        actions: this.checkActions, // actions
        segments: this.checkSegments, // segments
        rules: this.checkRules // rules
      };
    },
    // バリデーションを読み込む関数
    isUpValid: function isUpValid() {
      var msg = [];
      if (this.tasks.frameId == null || this.tasks.frameId === '') {
        msg.push('frameIdは必須です');
      } else if (this.upValidation.frameId === false) {
        msg.push('入力項目(frameId)に不備があります');
      }
      if (this.upValidation.name === false) {
        msg.push('タイトルは必須です');
      }
      msg = msg.concat(this.upValidation.pages);
      msg = msg.concat(this.upValidation.actions);
      msg = msg.concat(this.upValidation.rules);
      return msg.join('\n');
    },
    // ページ入力のバリデーション
    checkPages: function checkPages() {
      var pagesMsg = [];
      for (var i = 0; i < this.tasks.configuration.pages.length; i++) {
        // 空白チェック
        if (this.tasks.configuration.pages[i].pattern === '') {
          pagesMsg.push('表示（非表示）ページ[' + (i + 1) + ']:ドメイン下のパスは必須です');
        } else if (pageNgRegexp.test(this.tasks.configuration.pages[i].pattern) === true) {
          pagesMsg.push('表示（非表示）ページ[' + (i + 1) + ']:ドメイン下のパスに不備があります');
        }
        if (this.tasks.configuration.pages[i].mode === '') {
          pagesMsg.push('表示（非表示）ページ[' + (i + 1) + ']:modeは必須です');
        }
        // TODO:被りはバリデーションにないが、可能なら今後チェックにつける
      }
      return pagesMsg;
    },
    // アクション入力のバリデーション
    checkActions: function checkActions() {
      var ratioSum = Number(this.nonRatio);
      var actionMsg = [];

      // 重複チェック
      var noDuplicate = Object(lodash["uniqBy"])(this.tasks.configuration.actions, 'actionId');
      if (this.tasks.configuration.actions.length !== noDuplicate.length) {
        actionMsg.push('アクションが重複しています');
      }

      for (var i = 0; i < this.tasks.configuration.actions.length; i++) {
        // 空白チェック
        if (this.tasks.configuration.actions[i].ratio === '') {
          actionMsg.push('アクション[' + (i + 1) + ']:出現率は必須です');
        } else if (this.tasks.configuration.actions[i].ratio < 1 || this.tasks.configuration.actions[i].ratio > 100) {
          actionMsg.push('アクション[' + (i + 1) + ']:出現率に不備があります(1~100)');
        }
        ratioSum = ratioSum + Number(this.tasks.configuration.actions[i].ratio);
        // TODO:被りとアクションTypeの一致判定はバリデーションにないが、可能なら今後チェックにつける
      }
      // 比率の合計は1になっていること
      if (ratioSum !== 100) {
        actionMsg.push('比率の合計は100になっていません');
      }
      return actionMsg;
    },
    checkSegments: function checkSegments() {
      var segmentMsg = [];
      if (this.tasks.configuration.segments.length > 1) {
        segmentMsg.push('セグメントの複数指定は対応していません');
      }
      return segmentMsg;
    },
    // ルール入力のバリデーション
    checkRules: function checkRules(rule) {
      var ruleMsg = [];
      for (var i = 0; i < this.tasks.configuration.rules.length; i++) {
        // パターン別にバリデーションをかける
        switch (this.tasks.configuration.rules[i].type) {
          case 'visit-count':
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(訪問回数:count)に不備があります');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(訪問回数:operator)に不備があります');
            }
            break;
          case 'last-page-view':
            if (!!this.tasks.configuration.rules[i].threashold.trim() === false) {
              ruleMsg.push('最後のページビュー日時:threasholdは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(最後のページビュー日時:operator)に不備があります');
            }
            break;
          case 'page-view-count':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(ページビュー数:scope)に不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(ページビュー数:count)に不備があります');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(ページビュー数:operator)に不備があります');
            }
            break;
          case 'stay-seconds':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(滞在秒数:scope)に不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].seconds) === false) {
              ruleMsg.push('入力項目(滞在秒数:seconds)に不備があります');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(滞在秒数:operator)に不備があります');
            }
            break;
          case 'view-page-path':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(閲覧ページのパス:scope)に不備があります');
            }
            if (!!this.tasks.configuration.rules[i].page.trim() === false) {
              ruleMsg.push('閲覧ページのパス:pageは必須です');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(閲覧ページのパス:count)に不備があります');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(閲覧ページのパス:operator)に不備があります');
            }
            break;
          case 'last-page-path':
            if (!!this.tasks.configuration.rules[i].page.trim() === false) {
              ruleMsg.push('最後の閲覧ページのパス:pageは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(最後の閲覧ページのパス:operator)に不備があります');
            }
            break;
          case 'walk-3pages':
            if (!!this.tasks.configuration.rules[i].page1.trim() === false) {
              ruleMsg.push('3階層ページ遷移閲覧シナリオ:page1は必須です');
            }
            if (!!this.tasks.configuration.rules[i].page2.trim() === false) {
              ruleMsg.push('3階層ページ遷移閲覧シナリオ:page2は必須です');
            }
            if (!!this.tasks.configuration.rules[i].page3.trim() === false) {
              ruleMsg.push('3階層ページ遷移閲覧シナリオ:page3は必須です');
            }
            break;
          case 'referer':
            if (!!this.tasks.configuration.rules[i].page.trim() === false) {
              ruleMsg.push('リンク元ページ（リファラ）のホスト:pageは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(リンク元ページ（リファラ）のホスト:operator)に不備があります');
            }
            break;
          case 'utm-source':
            if (!!this.tasks.configuration.rules[i].value.trim() === false) {
              ruleMsg.push('閲覧ページのクエリキー（utm_source）:valueは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(閲覧ページのクエリキー（utm_source）:operator)に不備があります');
            }
            break;
          case 'src-link-path':
            if (!!this.tasks.configuration.rules[i].link.trim() === false) {
              ruleMsg.push('サイト内のリンク元ページのパス:linkは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(サイト内のリンク元ページのパス:operator)に不備があります');
            }
            break;
          case 'user-os':
            if (!!this.tasks.configuration.rules[i].value.trim() === false) {
              ruleMsg.push('アクセス時のOS名:valueは必須です');
            }
            if (!Object(lodash["includes"])(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(アクセス時のOS名:operator)に不備があります');
            }
            break;
          case 'stop-view-count':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(配信回数上限で配信を停止:scope)に不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(配信回数上限で配信を停止:count)に不備があります');
            }
            break;
          case 'stop-close-count':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(閉じられた回数で配信を停止:scope)に不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(閉じられた回数で配信を停止:count)に不備があります');
            }
            break;
          case 'stop-click-count':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(クリック回数で配信を停止:scope)に不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(クリック回数で配信を停止:count)に不備があります');
            }
            break;
          case 'day-period':
            if (!!this.tasks.configuration.rules[i].start.trim() === false) {
              ruleMsg.push('期間:startは必須です');
            }
            if (!!this.tasks.configuration.rules[i].end.trim() === false) {
              ruleMsg.push('期間:endは必須です');
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('期間:timezoneは必須です');
            }
            break;
          case 'day-of-week':
            var weekFlg = true;
            if (!Array.isArray(this.tasks.configuration.rules[i].values)) {
              this.tasks.configuration.rules[i].values = this.tasks.configuration.rules[i].values.split(',');
            }
            for (var t = 0; t < this.tasks.configuration.rules[i].values.length; t++) {
              if (!Object(lodash["includes"])(weekList, this.tasks.configuration.rules[i].values[t])) {
                weekFlg = false;
              }
            }
            if (!weekFlg) {
              ruleMsg.push('入力項目(曜日:value)に不備があります');
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('曜日:timezoneは必須です');
            }
            break;
          case 'day-time':
            if (!!this.tasks.configuration.rules[i].start.trim() === false) {
              ruleMsg.push('時間:startは必須です');
            }
            if (!!this.tasks.configuration.rules[i].end.trim() === false) {
              ruleMsg.push('時間:endは必須です');
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('時間:timezoneは必須です');
            }
            break;
          case 'frequency':
            if (!Object(lodash["includes"])(periodTypeList, this.tasks.configuration.rules[i].periodType)) {
              ruleMsg.push('頻度:periodTypeは必須です');
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('頻度:timezoneは必須です');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].interval) === false) {
              ruleMsg.push('頻度:intervalは必須です');
            }
            if (!Object(lodash["includes"])(minuteList, this.tasks.configuration.rules[i].minuteThreshold)) {
              ruleMsg.push('頻度:minuteThresholdは必須です');
            }
            if (!Object(lodash["includes"])(hourList, this.tasks.configuration.rules[i].hourThreshold) && (this.tasks.configuration.rules[i].periodType === 'week' || this.tasks.configuration.rules[i].periodType === 'month' || this.tasks.configuration.rules[i].periodType === 'day')) {
              ruleMsg.push('頻度:hourThresholdは必須です');
            }
            if (!Object(lodash["includes"])(dayOfWeekList, this.tasks.configuration.rules[i].dayOfWeekThreshold) && this.tasks.configuration.rules[i].periodType === 'week') {
              ruleMsg.push('頻度:dayOfWeekThresholdは必須です');
            }
            if (!Object(lodash["includes"])(dayList, this.tasks.configuration.rules[i].dayThreshold) && this.tasks.configuration.rules[i].periodType === 'month') {
              ruleMsg.push('頻度:dayThresholdは必須です');
            }
            break;
          case 'user-view-limit':
            if (!Object(lodash["includes"])(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('配信数上限:scopeに不備があります');
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('配信数上限:countに不備があります');
            }
            break;
          case 'unknow':
            break;
        }
      }
      return ruleMsg;
    }
  },

  methods: {
    callFrame: function callFrame() {
      stores.dispatch('frame', this.tasks);
    },
    updateFrame: function updateFrame() {
      var errMsg = this.isUpValid;
      if (errMsg === '') {
        stores.dispatch('checkSessionId');
        stores.dispatch('updateFrame', this.$router);
      } else {
        alert(errMsg);
      }
    },
    // 編集対象の枠を呼び出す
    goGetFrame: function goGetFrame() {
      this.$router.push('/delivery/get-frame?frameId=' + this.$route.query.frameId + '&fqdn=' + this.$route.query.fqdn);
    },
    // ページリストから選択したページを削除する
    deletePage: function deletePage(list) {
      this.tasks.configuration.pages.splice(this.tasks.configuration.pages.indexOf(list), 1);
    },
    // アクションリストから選択したアクションを削除する
    deleteAction: function deleteAction(list) {
      this.tasks.configuration.actions.splice(this.tasks.configuration.actions.indexOf(list), 1);
      stores.dispatch('ratioChange');
    },
    // セグメントリストから選択したセグメントを削除する
    deleteSegment: function deleteSegment(list) {
      this.tasks.configuration.segments.splice(this.tasks.configuration.segments.indexOf(list), 1);
      this.segment = '';
    },
    // ルールリストから選択したルールを削除する
    deleteRule: function deleteRule(list) {
      this.tasks.configuration.rules.splice(this.tasks.configuration.rules.indexOf(list), 1);
    },
    // ページを追加する
    createPage: function createPage() {
      this.tasks.configuration.pages.push({ pattern: '', mode: '' });
    },
    // アクションを追加する
    addActionThing: function addActionThing(addAction) {
      var actionIds = this.tasks.configuration.actions.map(function (value) {
        return value.actionId;
      });
      if (actionIds.length > 0 && actionIds.indexOf(addAction) >= 0) {
        alert(this.actionNames[addAction] + 'は存在します');
      } else {
        this.tasks.configuration.actions.push({ actionId: addAction, ratio: '' });
      }
      this.addAction = '';
    },
    // セグメントを追加する
    addSegmentThing: function addSegmentThing(addSegment) {
      this.tasks.configuration.segments.push({ segmentId: addSegment });
    },
    // アクション種別を変更したら追加可能なアクションリストを更新する
    selectActionType: function selectActionType(actionType) {
      stores.dispatch('getActionList', actionType);
      this.addAction = '';
    },
    // ルールを追加する
    addRuleThing: function addRuleThing(addRule) {
      this.tasks.configuration.rules.push(Object(lodash["cloneDeep"])(ruleFormatList[addRule]));
      this.addRule = '';
      this.selectRuleList = '';
      this.selectCategory = '';
    },
    ratioChange: function ratioChange() {
      stores.dispatch('ratioChange');
    },
    selectRuleCategory: function selectRuleCategory(selectCategory) {
      this.selectRuleList = categoryRuleList[selectCategory];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36fe621e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/delivery/frame/UpdateFrame.vue
var UpdateFrame_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"updateFrame"},[_c('main',{staticClass:"t-main"},[_c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('router-link',{staticClass:"a-text a-link",attrs:{"to":"/delivery/list-frame"}},[_vm._v("枠一覧")])],1),_vm._v(" "),_c('li',{staticClass:"m-breadcrumb__item"},[_c('router-link',{staticClass:"a-text a-link",attrs:{"to":{ path: 'get-frame', query: { fqdn: this.$route.query.fqdn, frameId: this.$route.query.frameId}}}},[_vm._v("枠詳細")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.updateFrameTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("frameId")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("frameIdを入力してください"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('h2',{staticClass:"a-title a-title--sub",staticStyle:{"margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.tasks.frameId))])])])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("タイトル")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("タイトルを入力してください"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.metadata.name),expression:"tasks.metadata.name"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：test"},domProps:{"value":(_vm.tasks.metadata.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks.metadata, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("表示（非表示）ページ")]),_vm._v(" "),_vm._l((_vm.tasks.configuration.pages),function(list){return _c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("ドメイン下のパスを正規表現で指定できます"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list.pattern),expression:"list.pattern"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"例：/contents/*"},domProps:{"value":(list.pattern)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, "pattern", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--30"},[_c('label',{staticClass:"m-form__label"},[_vm._v("mode（表示・非表示）"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(list.mode),expression:"list.mode"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.pageMode),function(val,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(val))])})],2)])])]),_vm._v(" "),_c('button',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deletePage(list)}}},[_vm._v("delete")])])}),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button a-button--danger",on:{"click":_vm.createPage}},[_vm._v("表示（非表示）ページを追加する")])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("セグメント")]),_vm._v(" "),(_vm.tasks.configuration.segments=='')?_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("セグメント登録"),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.segment),expression:"segment"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.segment=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.addSegmentThing(_vm.segment)}]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.segmentList),function(Segment){return _c('option',{domProps:{"value":Segment.segmentId}},[_vm._v(_vm._s(Segment.metadata.name))])})],2)])])]):_vm._e(),_vm._v(" "),(_vm.tasks.configuration.segments!='')?_c('label',{staticClass:"m-form__label"},[_vm._v("セグメントを空にすると、指定セグメントの変更ができます\n       "),_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v(_vm._s(_vm.tasks.configuration.segments[0].segmentId))])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deleteSegment(_vm.tasks.configuration.segments[0])}}},[_vm._v("delete")])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("アクション種別")]),_vm._v(" "),_c('label',{staticClass:"m-form__label"},[_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v(_vm._s(_vm.actionType))])])]),_vm._v(" "),_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("アクション設定")]),_vm._v(" "),_vm._l((_vm.tasks.configuration.actions),function(list){return _c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v(_vm._s(_vm.actionNames[list.actionId]))]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--20"},[_c('label',{staticClass:"m-form__label"},[_vm._v("出現率"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list.ratio),expression:"list.ratio"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","step":"1","max":"100","min":"1","placeholder":"パーセント"},domProps:{"value":(list.ratio)},on:{"change":function($event){return _vm.ratioChange()},"input":function($event){if($event.target.composing){ return; }_vm.$set(list, "ratio", $event.target.value)}}})])]),_vm._v(" "),_c('button',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deleteAction(list)}}},[_vm._v("delete")])])}),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--50"},[_vm._v("アクションを実行しない比率　"+_vm._s(_vm.nonRatio))])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--30"},[_vm._v("右タブからアクションを追加できます")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--30"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAction),expression:"addAction"}],staticClass:"m-form__input m-form__input--select m-form__item--20",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.addAction=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.addActionThing(_vm.addAction)}]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.actionList),function(action){return _c('option',{domProps:{"value":action.actionId}},[_vm._v(_vm._s(action.metadata.name))])})],2)])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('h2',{staticClass:"a-title a-title--sub"},[_vm._v("ルール")]),_vm._v(" "),_vm._l((_vm.tasks.configuration.rules),function(list){return _c('div',[_c('div',{staticClass:"m-form__item-wrapper"},[_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.rulememoList[list.type])+"\n         "),_c('h2',{staticClass:"a-title a-title--sub m-form__item--100"},[_vm._v(_vm._s(_vm.ruleList[list.type]))])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_vm._l((list),function(val,key){return _c('div',{staticClass:"m-form__item"},[(key!='type' && (key=='count' || key=='threashold' || key=='seconds'|| key=='interval'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"number","min":"1"},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e(),_vm._v(" "),(key!='type' && key=='operator' && (list.type=='visit-count' || list.type=='last-page-view' || list.type=='page-view-count' || list.type=='stay-seconds' || list.type=='view-page-path'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.operatorList),function(operator){return _c('option',{domProps:{"value":operator}},[_vm._v(_vm._s(_vm.jpList[operator]))])})],2)]):_vm._e(),_vm._v(" "),(key!='type' && key=='operator' && list.type!='visit-count' && list.type!='last-page-view' && list.type!='page-view-count' && list.type!='stay-seconds' && list.type!='view-page-path')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.strOperatorList),function(operator){return _c('option',{domProps:{"value":operator}},[_vm._v(_vm._s(_vm.jpList[operator]))])})],2)]):_vm._e(),_vm._v(" "),(key!='type' && key=='scope')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.scopeList),function(scope){return _c('option',{domProps:{"value":scope}},[_vm._v(_vm._s(_vm.jpList[scope]))])})],2)]):_vm._e(),_vm._v(" "),(key!='type' && list.type=='referer' && key=='page')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("リファラ（ドメイン）"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":""},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e(),_vm._v(" "),(key!='type' && list.type=='user-os' && key=='value')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("OS名"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":""},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e(),_vm._v(" "),(key!='type' && list.type!='referer' && list.type!='user-os' && (key=='page' || key=='page1' || key=='page2' || key=='page3' || key=='value' || key=='values' || key=='link'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":""},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e(),_vm._v(" "),(key=='timezone')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n          "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.timezoneList),function(val,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(val))])})],2)]):_vm._e(),_vm._v(" "),(key=='periodType')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n          "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.periodTypeList),function(val){return _c('option',{domProps:{"value":val}},[_vm._v(_vm._s(_vm.jpList[val]))])})],2)]):_vm._e(),_vm._v(" "),(key=='dayOfWeekThreshold' && list.periodType == 'week')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n          "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.dayOfWeekList),function(val){return _c('option',{domProps:{"value":val}},[_vm._v(_vm._s(_vm.jpList[val]))])})],2)]):_vm._e(),_vm._v(" "),(list.type=='frequency' && key=='minuteThreshold')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n         "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.minuteList),function(val){return _c('option',{domProps:{"value":val}},[_vm._v(_vm._s(val))])})],2)]):_vm._e(),_vm._v(" "),(list.type=='frequency' && key=='dayThreshold' && list.periodType == 'month')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n         "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.dayList),function(val){return _c('option',{domProps:{"value":val}},[_vm._v(_vm._s(val))])})],2)]):_vm._e(),_vm._v(" "),(list.type=='frequency' && key=='hourThreshold' && (list.periodType == 'day' || list.periodType == 'month' || list.periodType == 'week'))?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v("\n         "+_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(list, key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.hourList),function(val){return _c('option',{domProps:{"value":val}},[_vm._v(_vm._s(val))])})],2)]):_vm._e(),_vm._v(" "),(key!='type' && (key=='start' || key=='end') && list.type!='day-period')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"time"},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e(),_vm._v(" "),(key!='type' && (key=='start' || key=='end') && list.type=='day-period')?_c('label',{staticClass:"m-form__label m-form__item--100"},[_vm._v(_vm._s(_vm.jpList[key])),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(list[key]),expression:"list[key]"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"datetime-local"},domProps:{"value":(list[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(list, key, $event.target.value)}}})]):_vm._e()])}),_vm._v(" "),_c('button',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deleteRule(list)}}},[_vm._v("delete")])],2)])}),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('h2',{staticClass:"a-title a-title--sub m-form__item--25"},[_vm._v("右タブからルールを追加できます")]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--30"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectCategory),expression:"selectCategory"}],staticClass:"m-form__input m-form__input--select m-form__item--20",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.selectRuleCategory(_vm.selectCategory)}]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.categoryList),function(val,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(val))])})],2)]),_vm._v(" "),_c('div',{staticClass:"m-form__item m-form__item--30"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.addRule),expression:"addRule"}],staticClass:"m-form__input m-form__input--select m-form__item--20",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.addRule=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.addRuleThing(_vm.addRule)}]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("--選択してください--")]),_vm._v(" "),_vm._l((_vm.selectRuleList),function(val,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(val))])})],2)])]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.updateFrame}},[_vm._v("更新")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.goGetFrame}},[_vm._v("枠詳細画面に戻る")])])],2)])}
var UpdateFrame_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("枠編集")])])}]
var UpdateFrame_esExports = { render: UpdateFrame_render, staticRenderFns: UpdateFrame_staticRenderFns }
/* harmony default export */ var frame_UpdateFrame = (UpdateFrame_esExports);
// CONCATENATED MODULE: ./src/components/delivery/frame/UpdateFrame.vue
var UpdateFrame_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UpdateFrame___vue_template_functional__ = false
/* styles */
var UpdateFrame___vue_styles__ = null
/* scopeId */
var UpdateFrame___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UpdateFrame___vue_module_identifier__ = null
var UpdateFrame_Component = UpdateFrame_normalizeComponent(
  UpdateFrame,
  frame_UpdateFrame,
  UpdateFrame___vue_template_functional__,
  UpdateFrame___vue_styles__,
  UpdateFrame___vue_scopeId__,
  UpdateFrame___vue_module_identifier__
)

/* harmony default export */ var delivery_frame_UpdateFrame = (UpdateFrame_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/udata/decisiontree/ListDecisionTree.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ListDecisionTree = ({
  name: 'listDecisionTree',
  data: function data() {
    var columns = { slug: 'slug', title: 'タイトル', description: '説明', delete: '削除' };
    return {
      listDecisionTreeTitle: '決定木一覧',
      columns: columns,
      datasourceId: ''
    };
  },
  created: function created() {
    stores.dispatch('getDatasourceInListData');
    stores.dispatch('getDecisiontreeListData', this.$route.query.datasourceId);
  },

  // ajaxで取得してきた
  computed: {
    tasks: {
      get: function get() {
        return stores.state.decisiontree.decisiontreelist;
      }
    },
    datasources: {
      get: function get() {
        return stores.state.decisiontree.datasourceInList;
      }
    }
  },
  methods: {
    callDecisionTreeList: function callDecisionTreeList() {
      stores.dispatch('decisiontreelist', this.tasks);
    },
    createDecisionTreeLink: function createDecisionTreeLink() {
      this.$router.push('/udata/create-decision-tree?datasourceId=' + this.datasourceId);
    },
    changeDataSourceId: function changeDataSourceId() {
      stores.dispatch('getDecisiontreeListData', this.datasourceId);
      this.$router.push('/udata/list-decision-tree?datasourceId=' + this.datasourceId);
    },
    deleteDecisionTree: function deleteDecisionTree(decisionTree) {
      if (confirm(decisionTree.datasourceId + 'に登録された' + decisionTree.decisionTreeId + 'のバージョン' + decisionTree.versionId + 'を削除しますか？')) {
        stores.dispatch('decisionTreeDelete', decisionTree);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d2ed5a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/udata/decisiontree/ListDecisionTree.vue
var ListDecisionTree_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listDecisionTree"},[_c('main',{staticClass:"t-main"},[_vm._m(0),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.listDecisionTreeTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("datasourceId"),_c('span',{staticClass:"m-form__input--select-wrapper"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.datasourceId),expression:"datasourceId"}],staticClass:"m-form__input m-form__input--select",attrs:{"name":"category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.datasourceId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeDataSourceId]}},_vm._l((_vm.datasources),function(datasource){return _c('option',{domProps:{"value":datasource.datasourceId}},[_vm._v("\n                 "+_vm._s(datasource.datasourceId)+"\n               ")])}),0)])])])]),_vm._v(" "),(_vm.datasourceId)?_c('div',[_c('div',{staticClass:"m-form__item-wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.createDecisionTreeLink}},[_vm._v("新規登録")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"a-section"},[_c('table',{staticClass:"m-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.columns.slug))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.title))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.description))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.columns.delete))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.tasks),function(task){return _c('tr',[_c('td',[_c('router-link',{attrs:{"to":{ path: 'update-decision-tree', query: { datasourceId: _vm.datasourceId, treeId: task.treeId}}}},[_vm._v(_vm._s(task.treeId))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(task.metadata.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(task.metadata.description))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"m-form__delete",on:{"click":function($event){return _vm.deleteDecisionTree(task)}}})])])}),0)])])]):_vm._e()])])}
var ListDecisionTree_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("決定木一覧")])])])}]
var ListDecisionTree_esExports = { render: ListDecisionTree_render, staticRenderFns: ListDecisionTree_staticRenderFns }
/* harmony default export */ var decisiontree_ListDecisionTree = (ListDecisionTree_esExports);
// CONCATENATED MODULE: ./src/components/udata/decisiontree/ListDecisionTree.vue
var ListDecisionTree_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ListDecisionTree___vue_template_functional__ = false
/* styles */
var ListDecisionTree___vue_styles__ = null
/* scopeId */
var ListDecisionTree___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ListDecisionTree___vue_module_identifier__ = null
var ListDecisionTree_Component = ListDecisionTree_normalizeComponent(
  ListDecisionTree,
  decisiontree_ListDecisionTree,
  ListDecisionTree___vue_template_functional__,
  ListDecisionTree___vue_styles__,
  ListDecisionTree___vue_scopeId__,
  ListDecisionTree___vue_module_identifier__
)

/* harmony default export */ var udata_decisiontree_ListDecisionTree = (ListDecisionTree_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/udata/decisiontree/CreateDecisionTree.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var CreateDecisionTree = ({
  name: 'createDecisionTree',
  data: function data() {
    return {
      createDecisionTreeTitle: '決定木登録'
    };
  },
  created: function created() {
    stores.state.decisiontree.datasourceId = this.$route.query.datasourceId;
    stores.dispatch('formatDecisionTreeData');
  },

  computed: {
    tasks: {
      get: function get() {
        return stores.state.decisiontree.decisiontree;
      }
    },
    // バリデーション関数を定義する
    validation: function validation() {
      return {
        treeId: treeIdRegexp.test(this.tasks.treeId),
        name: nameRegexp.test(this.tasks.name),
        model: modelRegexp.test(this.tasks.model)
      };
    },
    // バリデーションを読み込む関数
    isValid: function isValid() {
      var msg = [];
      if (this.tasks.treeId === '') {
        msg.push('treeIdは必須です');
      } else if (this.validation.treeId === false) {
        msg.push('入力項目(treeId)に不備があります');
      }
      if (this.tasks.name === '') {
        msg.push('タイトルは必須です');
      } else if (this.validation.name === false) {
        msg.push('入力項目(タイトル)に不備があります');
      }
      if (this.tasks.model === '') {
        msg.push('ファイルは必須です');
      } else if (this.validation.model === false) {
        msg.push('入力項目(ファイル)に不備があります');
      }
      return msg.join('\n');
    }
  },

  methods: {
    createDecisionTree: function createDecisionTree() {
      var errMsg = this.isValid;
      if (errMsg === '') {
        stores.dispatch('createDecisionTree', this.$router);
      } else {
        alert(errMsg);
      }
    },
    goListDecisionTree: function goListDecisionTree() {
      this.$router.push('/udata/list-decision-tree');
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (files) {
        // base64に変換する
        var fileReader = new FileReader();
        fileReader.onload = function () {
          stores.state.decisiontree.decisiontree.model = this.result.split(',')[1];
        };
        fileReader.readAsDataURL(files[0]);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d9d5e58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/udata/decisiontree/CreateDecisionTree.vue
var CreateDecisionTree_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"createDecisonTree"},[_c('main',{staticClass:"t-main"},[_c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('router-link',{staticClass:"a-text a-link",attrs:{"to":"/robotalk/list-decision-tree"}},[_vm._v("決定木一覧")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.createDecisionTreeTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("treeId"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.treeId),expression:"tasks.treeId"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"treeIdを入力してください"},domProps:{"value":(_vm.tasks.treeId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks, "treeId", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("タイトル"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.name),expression:"tasks.name"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"タイトルを入力してください。"},domProps:{"value":(_vm.tasks.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('input',{staticClass:"m-form__input m-form__input--text",attrs:{"type":"file"},on:{"change":_vm.onFileChange}})])]),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.createDecisionTree}},[_vm._v("登録")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.goListDecisionTree}},[_vm._v("キャンセル")])])])])}
var CreateDecisionTree_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("決定木登録")])])}]
var CreateDecisionTree_esExports = { render: CreateDecisionTree_render, staticRenderFns: CreateDecisionTree_staticRenderFns }
/* harmony default export */ var decisiontree_CreateDecisionTree = (CreateDecisionTree_esExports);
// CONCATENATED MODULE: ./src/components/udata/decisiontree/CreateDecisionTree.vue
var CreateDecisionTree_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateDecisionTree___vue_template_functional__ = false
/* styles */
var CreateDecisionTree___vue_styles__ = null
/* scopeId */
var CreateDecisionTree___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateDecisionTree___vue_module_identifier__ = null
var CreateDecisionTree_Component = CreateDecisionTree_normalizeComponent(
  CreateDecisionTree,
  decisiontree_CreateDecisionTree,
  CreateDecisionTree___vue_template_functional__,
  CreateDecisionTree___vue_styles__,
  CreateDecisionTree___vue_scopeId__,
  CreateDecisionTree___vue_module_identifier__
)

/* harmony default export */ var udata_decisiontree_CreateDecisionTree = (CreateDecisionTree_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/udata/decisiontree/UpdateDecisionTree.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UpdateDecisionTree = ({
  name: 'updateDecisonTree',
  data: function data() {
    return { updateDecisionTreeTitle: '決定木編集' };
  },
  created: function created() {
    stores.state.decisiontree.datasourceId = this.$route.query.datasourceId;
    this.tasks.treeId = this.$route.query.treeId;
    stores.dispatch('getDecisiontreeData');
  },

  computed: {
    tasks: {
      get: function get() {
        return stores.state.decisiontree.decisiontree;
      }
    },
    // バリデーション関数を定義する
    upValidation: function upValidation() {
      return {
        treeId: treeIdRegexp.test(this.tasks.treeId),
        name: nameRegexp.test(this.tasks.name),
        model: modelRegexp.test(this.tasks.model)
      };
    },
    // バリデーションを読み込む関数
    isUpValid: function isUpValid() {
      var msg = [];
      if (this.tasks.treeId == null || this.tasks.treeId === '') {
        msg.push('treeIdは必須です');
      } else if (this.upValidation.treeId === false) {
        msg.push('入力項目(treeId)に不備があります');
      }
      if (this.tasks.name == null || this.tasks.name === '') {
        msg.push('タイトルは必須です');
      } else if (this.upValidation.name === false) {
        msg.push('入力項目(タイトル)に不備があります');
      }
      if (this.tasks.model == null || this.tasks.model === '') {
        msg.push('ファイルは必須です');
      } else if (this.upValidation.model === false) {
        msg.push('入力項目(ファイル)に不備があります');
      }
      return msg.join('\n');
    }
  },
  methods: {
    callDecisionTree: function callDecisionTree() {
      stores.dispatch('decisiontree', this.tasks);
    },
    updateDecisionTree: function updateDecisionTree() {
      var errMsg = this.isUpValid;
      if (errMsg === '') {
        stores.dispatch('updateDecisionTree', this.$router);
      } else {
        alert(errMsg);
      }
    },
    goListDecisionTree: function goListDecisionTree() {
      this.$router.push('/udata/list-decision-tree');
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (files) {
        // base64に変換する
        var fileReader = new FileReader();
        fileReader.onload = function () {
          stores.state.decisiontree.decisiontree.model = this.result.split(',')[1];
        };
        fileReader.readAsDataURL(files[0]);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0718dde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/udata/decisiontree/UpdateDecisionTree.vue
var UpdateDecisionTree_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"updateDecisonTree"},[_c('main',{staticClass:"t-main"},[_c('ol',{staticClass:"m-breadcrumb"},[_c('li',{staticClass:"m-breadcrumb__item"},[_c('router-link',{staticClass:"a-text a-link",attrs:{"to":"/udata/list-decision-tree"}},[_vm._v("決定木一覧")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('h1',{staticClass:"a-title"},[_vm._v(_vm._s(_vm.updateDecisionTreeTitle))]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("treeId"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.treeId),expression:"tasks.treeId"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"treeIdを入力してください"},domProps:{"value":(_vm.tasks.treeId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks, "treeId", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('label',{staticClass:"m-form__label"},[_vm._v("タイトル"),_c('span',{staticClass:"m-form__label--necessary"},[_vm._v("※必須")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tasks.name),expression:"tasks.name"}],staticClass:"m-form__input m-form__input--text",attrs:{"type":"text","placeholder":"タイトルを入力してください。"},domProps:{"value":(_vm.tasks.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tasks, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"m-form__item-wrapper"},[_c('div',{staticClass:"m-form__item m-form__item--50"},[_c('input',{staticClass:"m-form__input m-form__input--text",attrs:{"type":"file"},on:{"change":_vm.onFileChange}})])]),_vm._v(" "),_c('p',{staticClass:"a-button__wrapper"},[_c('button',{staticClass:"a-button",on:{"click":_vm.updateDecisionTree}},[_vm._v("更新")]),_vm._v(" "),_c('button',{staticClass:"a-button a-button--cansel",on:{"click":_vm.goListDecisionTree}},[_vm._v("キャンセル")])])])])}
var UpdateDecisionTree_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"m-breadcrumb__item"},[_c('span',{staticClass:"a-text"},[_vm._v("決定木編集")])])}]
var UpdateDecisionTree_esExports = { render: UpdateDecisionTree_render, staticRenderFns: UpdateDecisionTree_staticRenderFns }
/* harmony default export */ var decisiontree_UpdateDecisionTree = (UpdateDecisionTree_esExports);
// CONCATENATED MODULE: ./src/components/udata/decisiontree/UpdateDecisionTree.vue
var UpdateDecisionTree_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UpdateDecisionTree___vue_template_functional__ = false
/* styles */
var UpdateDecisionTree___vue_styles__ = null
/* scopeId */
var UpdateDecisionTree___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UpdateDecisionTree___vue_module_identifier__ = null
var UpdateDecisionTree_Component = UpdateDecisionTree_normalizeComponent(
  UpdateDecisionTree,
  decisiontree_UpdateDecisionTree,
  UpdateDecisionTree___vue_template_functional__,
  UpdateDecisionTree___vue_styles__,
  UpdateDecisionTree___vue_scopeId__,
  UpdateDecisionTree___vue_module_identifier__
)

/* harmony default export */ var udata_decisiontree_UpdateDecisionTree = (UpdateDecisionTree_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f032c2ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error/Error.vue
var Error_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('main',{staticClass:"t-main"},[_c('h1',{staticClass:"a-title"},[_vm._v("HTTP Status "+_vm._s(_vm.$route.params.code))]),_vm._v(" "),(_vm.$route.params.code === '400')?_c('div',[_vm._v("\n      Bad Request\n    ")]):_vm._e(),_vm._v(" "),(_vm.$route.params.code === '403')?_c('div',[_vm._v("\n      Forbidden\n    ")]):_vm._e(),_vm._v(" "),(_vm.$route.params.code === '404')?_c('div',[_vm._v("\n      Not Found\n    ")]):_vm._e(),_vm._v(" "),(_vm.$route.params.code === '500')?_c('div',[_vm._v("\n      Internal Server Error\n    ")]):_vm._e()])])}
var Error_staticRenderFns = []
var Error_esExports = { render: Error_render, staticRenderFns: Error_staticRenderFns }
/* harmony default export */ var Error = (Error_esExports);
// CONCATENATED MODULE: ./src/components/error/Error.vue
var Error_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var Error___vue_template_functional__ = false
/* styles */
var Error___vue_styles__ = null
/* scopeId */
var Error___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Error___vue_module_identifier__ = null
var Error_Component = Error_normalizeComponent(
  __vue_script__,
  Error,
  Error___vue_template_functional__,
  Error___vue_styles__,
  Error___vue_scopeId__,
  Error___vue_module_identifier__
)

/* harmony default export */ var error_Error = (Error_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d7a727c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HealthCheck.vue
var HealthCheck_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var HealthCheck_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HealthCheck"},[_c('main',{staticClass:"t-main"},[_c('p',[_vm._v("ok!")])])])}]
var HealthCheck_esExports = { render: HealthCheck_render, staticRenderFns: HealthCheck_staticRenderFns }
/* harmony default export */ var HealthCheck = (HealthCheck_esExports);
// CONCATENATED MODULE: ./src/components/HealthCheck.vue
var HealthCheck_normalizeComponent = __webpack_require__("VU/8")
/* script */
var HealthCheck___vue_script__ = null
/* template */

/* template functional */
var HealthCheck___vue_template_functional__ = false
/* styles */
var HealthCheck___vue_styles__ = null
/* scopeId */
var HealthCheck___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HealthCheck___vue_module_identifier__ = null
var HealthCheck_Component = HealthCheck_normalizeComponent(
  HealthCheck___vue_script__,
  HealthCheck,
  HealthCheck___vue_template_functional__,
  HealthCheck___vue_styles__,
  HealthCheck___vue_scopeId__,
  HealthCheck___vue_module_identifier__
)

/* harmony default export */ var components_HealthCheck = (HealthCheck_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js


















vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var src_router = (new vue_router_esm["a" /* default */]({
  mode: 'hash',
  routes: [{ path: '/delivery/list-action', name: 'listAction', component: delivery_action_ListAction }, // アクションリスト
  { path: '/delivery/create-action', name: 'createAction', component: delivery_action_CreateAction }, // アクションの新規登録
  { path: '/delivery/update-action', name: 'updateAction', component: delivery_action_UpdateAction }, // アクションの詳細、編集
  { path: '/delivery/list-domain', name: 'listDomain', component: delivery_domain_ListDomain }, // ドメインリスト
  { path: '/delivery/create-domain', name: 'createDomain', component: delivery_domain_CreateDomain }, // ドメインの新規登録
  { path: '/delivery/update-domain', name: 'updateDomain', component: delivery_domain_UpdateDomain }, // ドメインの詳細、編集
  { path: '/delivery/list-frame', name: 'listFrame', component: delivery_frame_ListFrame }, // 枠一覧
  { path: '/delivery/get-frame', name: 'getFrame', component: delivery_frame_GetFrame }, // 枠の詳細
  { path: '/delivery/create-frame', name: 'createFrame', component: delivery_frame_CreateFrame }, // 枠の新規登録
  { path: '/delivery/update-frame', name: 'updateFrame', component: delivery_frame_UpdateFrame }, // 枠の詳細、編集
  { path: '/udata/list-decision-tree', name: 'listDecisionTree', component: udata_decisiontree_ListDecisionTree }, // 決定木リスト
  { path: '/udata/create-decision-tree', name: 'createDecisionTree', component: udata_decisiontree_CreateDecisionTree }, // 決定木の新規登録
  { path: '/udata/update-decision-tree', name: 'updateDecisionTree', component: udata_decisiontree_UpdateDecisionTree }, // 決定木の詳細、編集
  { path: '/error/:code', name: 'error', component: error_Error }, // エラー
  { path: '/healthcheck.txt', name: 'healthcheck', component: components_HealthCheck }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.bcb7764fd17c7573f793.js